<template>
    <div class="checkout">
        <Navbar >
            <template #navMsg>
<!--                <b-alert show variant="danger">We are aware of an issue currently affecting new orders. We are working towards a fix and appreciate your patience and understanding.</b-alert>-->
            </template>
        </Navbar>


        <section class="py-4 bg-light">
            <div class="container">
                <div class="d-none">{{quote}}</div>
                <div class="d-flex mb-3 row">
                    <h3 class="align-self-center mr-3">Checkout <span v-if="quote">From Quote</span> </h3>
                    <div class="align-self-center ml-auto text-right">
                        <router-link :to="{name: 'cart'}" class="btn btn-link">
                            Back to Shopping Cart
                        </router-link>
                        <b-btn variant="link" @click="hideForm()" class="btn btn-link" v-show="displayForm">
                            Edit Order
                        </b-btn>
                    </div>
                </div>
                <div v-if="subtotal >= 5000" class="alert alert-warning row">
                    <h5>Wow, This looks like a big order!</h5>
                    <div>
                        Please contact us at: <a href="tel:8663118734">(866) 311-8734</a> for assistance.
                    </div>
                </div>
                <div class="text-danger" v-if="quote">
                    Some fields from your quote cannot be edited.<br/>
                    If you need to make changes, please reach out to your Account Manager.
                </div>
                <div class="row">
                    <!-- Left Side -->
                    <div class="col-xl-8">
                        <!-- Checkout Form -->
                        <form v-show="!showPaymentPage">
                            <fieldset :disabled="subtotal >= 5000">
                            <div class="card mb-3">
                                <h5 class="card-header">
                                    <font-awesome-icon :icon="['fad', 'truck']" class="text-primary" fixed-width /> Shipping
                                </h5>
                                <div class="card-body">

                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <label for="first_name">Shipping First Name *</label>
                                                <input
                                                    type="text"

                                                    ref="shippingFirstName"

                                                    class="form-control"
                                                    :class="{'is-invalid': validating && !shipping.first_name}"

                                                    v-model="shipping.first_name"
                                                    :disabled="isReadOnly"
                                                >
                                                <div class="invalid-feedback">
                                                    First Name is required
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <label for="last_name">Shipping Last Name *</label>
                                                <input
                                                    type="text"

                                                    ref="shippingLastName"

                                                    class="form-control"
                                                    :class="{'is-invalid': validating && !shipping.last_name}"

                                                    v-model="shipping.last_name"
                                                    :disabled="isReadOnly"
                                                >
                                                <div class="invalid-feedback">
                                                    Last Name is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="email">Shipping Email Address *</label>
                                        <b-input
                                            id="shipping_email"
                                            type="email"

                                            ref="shippingEmailAddress"
                                            class="form-control"
                                            :class="{'is-invalid': validShippingEmail}"

                                            v-model="shippingEmail"
                                            :disabled="isReadOnly"
                                        />
                                        <div class="invalid-feedback">
                                            Email Address is required
                                        </div>
                                    </div>

                                    <div v-if="!isHomeschoolStore" class="mb-3">
                                        <div class="form-group mb-0">
                                            <label for="school_search">Find School To Ship To*</label>
                                            <span class="loader" v-show="isLoading"></span>
                                            <span style="opacity: 0.05">{{shipping.school.id}}</span>
                                            <multiselect
                                                ref="schoolSearch"

                                                :class="{'is-invalid': validating && !school_search}"

                                                placeholder="Search by Zip Code"

                                                v-model="school_search"

                                                :options="schools"
                                                :disabled="isReadOnly"

                                                track-by="name"
                                                label="name"
                                                :searchable="true"
                                                :loading="isLoading"
                                                :internal-search="false"
                                                @search-change="searchSchools"
                                                @select="setSchool"
                                                @remove="unsetSchool"
                                            >
                                            </multiselect>
                                            <div class="invalid-feedback">
                                                Please find and select a school
                                            </div>
                                        </div>

                                        <!-- No address in DB -->
                                        <div v-show="shipping.school.id && needs_shipping_address">
                                            <b-alert show variant="danger" class="mt-2">We do not have all the required information for this school. Please enter the shipping address below.</b-alert>
                                            <AddressForm v-model="shipping.school"
                                                         :form-validated="validating"
                                                         :validate="true"
                                                         @validated="validateAddress"
                                                         ref="schoolShippingForm" />
                                        </div>

                                        <div v-if="shipping.school.id && !needs_shipping_address" class="text-muted mt-3">
                                            <div>{{shipping.school.first_name}} {{shipping.school.last_name}}</div>
                                            <div>{{shipping.school.name}}</div>
                                            <div>{{shipping.school.address}}</div>
                                            <div>{{shipping.school.city}}, {{shipping.school.state}} {{shipping.school.zip}}</div>
                                        </div>

                                    </div>

                                    <div v-show="address_type !== 'school' || (address_type == 'school' && shipping.id)" class="my-3">
                                        <div v-if="!isHomeschoolStore" v-show="address_type !== 'school'" class="form-group">
                                            <label for="school-name">
                                                School Name To Ship To*
                                            </label>
                                            <input
                                                type="text"

                                                ref="shippingSchoolName"

                                                class="form-control"
                                                :class="{'is-invalid': validating && !shipping.school.name}"

                                                v-model="shipping.school.name"

                                                :disabled="address_type == 'school' || isReadOnly"
                                            >

                                            <!-- <small id="schoolNameHelp" class="form-text text-muted">If N/A, input "homeschool"</small> -->

                                            <div class="invalid-feedback">
                                                School Name is required
                                            </div>
                                        </div>

                                        <AddressForm v-model="shipping.school"
                                                     :form-validated="validating"
                                                     :validate="true"
                                                     :disabled="isReadOnly"
                                                     @validated="validateAddress"
                                                     ref="customShippingForm"/>

                                        <div class="form-group mb-0">
                                            <label for="school_phone">Shipping Phone Number <span v-if="isHomeschoolStore">*</span></label>
                                            <input
                                                type="tel"

                                                ref="shippingSchoolPhone"

                                                class="form-control"
                                                :class="{'is-invalid': validShippingPhone}"
                                                :required="isHomeschoolStore"
                                                refs="shippingPhone"

                                                v-model="shipping.school.phone"

                                                :disabled="address_type == 'school' || isReadOnly"
                                                @blur="shipping.school.phone = sanitizePhone(shipping.school.phone)"
                                            >
                                            <div class="invalid-feedback">
                                                Please enter a valid phone number
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="school_year">School Year *</label>
                                        <input
                                            ref="shippingSchoolYear"

                                            class="form-control"
                                            :class="{'is-invalid': validating && !shipping.school_year}"
                                            disabled
                                            :value="`${selectedSchoolYear-1}-${selectedSchoolYear}`"
                                        />

                                         <span style="color: red">Shipping for the upcoming school year begins in April</span>

                                        <div class="invalid-feedback">
                                            School Year is required
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="openday">School Start Date</label>
                                        <div>
                                            <template v-if="isReadOnly">
                                                <b-input id="openday" :value="openday" :disabled="isReadOnly"/>
                                            </template>
                                            <v-date-picker v-model="openday" v-else>
                                                <template v-slot="{ inputValue, inputEvents }">
                                                    <b-input
                                                        :value="inputValue"
                                                        v-on="inputEvents"
                                                    />
                                                </template>
                                            </v-date-picker>
                                        </div>
                                    </div>
                                    <div ref="shipPartial" class="form-group" :class="{'is-invalid': shipPartialInvalid}">
                                        <div>
                                            <label class="mr-2">Shipping <span v-if="isHomeschoolStore">*</span></label>
                                            <font-awesome-icon id="ship_partial" :icon="['fas', 'info-circle']" ></font-awesome-icon>
                                        </div>
                                        <b-popover target="ship_partial" triggers="hover">
                                            <p><strong>Ship all materials together: </strong>If you want all your products to arrive together, please be aware this may cause your shipments to be delayed until all materials are in stock and ready to ship.</p>
                                            <p><strong>Ship each product when in stock: </strong>Shipments of social studies, science, or well-being products may ship at different times depending on when the print product is in stock and ready to ship.</p>
                                        </b-popover>
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <b-checkbox ref="cantShipPartial" type="checkbox" class="form-check-input" v-model="shipping.cantShipPartial" :disabled="isReadOnly">
                                                    Ship all materials together
                                                </b-checkbox>
                                                <!--                                                    <input ref="shippingFulfillment" class="form-check-input" type="radio" name="shipping.fulfillment" v-model="shipping.fulfillment" value="cant_ship_partial" required>Ship all materials together-->
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <b-checkbox ref="canShipPartial" type="checkbox" class="form-check-input" v-model="shipping.canShipPartial" :disabled="isReadOnly">
                                                    Ship each product when in stock
                                                </b-checkbox>
                                                <!--                                                    <input class="form-check-input" type="radio" name="shipping.fulfillment" v-model="shipping.fulfillment" value="can_ship_partial" required>Ship each product when in stock-->
                                            </label>
                                        </div>
                                        <div v-if="shipPartialInvalid" class="text-danger">Please select a shipping option</div>
                                    </div>

                                    <div
                                        :class="{'is-invalid': validating && (arriveWindowRangeError != null)}"
                                    >
                                        <div ref="blackoutWindow">Select date ranges that you are <strong style="color: red;">NOT</strong> available to receive shipment</div>
                                        <div class="mt-2"><b-checkbox id="blackout_none" v-model="blackoutNoWindows" name="blackoutNoWindows" :disabled="isReadOnly">I can receive shipment at any time</b-checkbox></div>
                                        <!-- Blackout Window -->
                                        <div v-show="!blackoutNoWindows">
                                            <div v-for="(blackoutWindow, i) in blackoutWindows" :key="`window_${i}`">
                                                <v-date-picker
                                                    class="mt-1"
                                                    mode="range"
                                                    is-range
                                                    color="purple"
                                                    v-model="blackoutWindows[i]"
                                                    :disabled-dates="getDisabledDates(i)"
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                                    :columns="$screens({ default: 1, lg: 2 })"
                                                    :rows="$screens({ default: 2, lg: 1 })"
                                                    show-caps
                                                    is-inline
                                                    is-double-paned
                                                    @input="validateRange($event, i)"
                                                    :disabled="isReadOnly"
                                                    :ref="`blackoutWindow_${i}`"
                                                />
                                                <b-input-group
                                                    class="mt-1 w-75 date-label"
                                                    @click="toggleWindow(i)"
                                                >
                                                    <template #prepend>
                                                        <b-input-group-text><font-awesome-icon :icon="['fas','calendar-times']"></font-awesome-icon></b-input-group-text>
                                                    </template>
                                                    <b-form-input
                                                        type="text"
                                                        class="date-label"
                                                        :value="dateRangeText(blackoutWindows[i])"

                                                        readonly
                                                    ></b-form-input>
                                                    <template #append>
                                                        <b-button type="link" variant="danger" size="sm" @click="deleteWindow(i)">
                                                            <font-awesome-icon :icon="['fas','trash-alt']"></font-awesome-icon>
                                                        </b-button>
                                                    </template>
                                                </b-input-group>
                                            </div>
                                            <div class="text-danger">{{arriveWindowRangeError}}</div>
                                            <b-button type="button"
                                                      size="sm"
                                                      variant="primary"
                                                      @click="addWindow()"
                                                      :disabled="blackoutWindows.length >= 5 || isReadOnly"
                                                      class="mt-3">
                                                Add Date Range
                                            </b-button>
                                        </div>

                                    </div>

                                    <div class="text-muted mt-3">
                                        <small>
                                            We are not responsible for lost, held, or damaged packages nor weather delays, carrier delivery errors, or incorrect shipping information.
                                        </small>
                                    </div>

                                    <div class="text-warning mt-3">
                                        <small>
                                            * denotes required fields
                                        </small>
                                    </div>

                                </div>
                            </div>

                            <div class="card" v-if="total > 0">
                                <h5 class="card-header">
                                    <font-awesome-icon :icon="['fad', 'credit-card']" class="text-success" fixed-width /> Payment
                                </h5>
                                <div class="card-body">

                                    <div v-if="showDiscountField">
                                        <h5>Discount</h5>
                                        <form @submit.prevent="applyDiscountCode(discount_code)" class="mb-4">
                                            <div class="input-group">
                                                <input
                                                    type="text"

                                                    ref="discountCode"

                                                    class="form-control"
                                                    :class="{'is-invalid': invalidDiscountCode}"

                                                    v-model="discount_code"

                                                    @input="invalidDiscountCode = false"

                                                    :disabled="isReadOnly"
                                                    :readonly="discount"
                                                >
                                                <div class="input-group-append">
                                                    <template v-if="discount">
                                                        <button
                                                            type="button"

                                                            class="btn btn-sm btn-danger"

                                                            @click.prevent="clearDiscount"
                                                        >
                                                            <font-awesome-icon :icon="['far', 'times']" fixed-width />
                                                        </button>
                                                    </template>
                                                    <button
                                                        v-if="!discount"

                                                        type="submit"

                                                        class="btn btn-primary"

                                                        :disabled="applyingDiscountCode || isReadOnly"
                                                    >
                                                                <span v-if="applyingDiscountCode">
                                                                    <font-awesome-icon :icon="['fad', 'circle-notch']" spin />
                                                                </span>
                                                        <span v-else>
                                                                    Apply
                                                                </span>
                                                    </button>
                                                </div>
                                            </div>

                                            <small v-if="!invalidDiscountCode" class="form-text text-muted">Add a promotion code or voucher</small>

                                            <div
                                                class="invalid-feedback"
                                                :class="{'d-block': invalidDiscountCode}"
                                            >
                                                Discount Code Invalid. Contact customer service for assistance.
                                            </div>
                                        </form>
                                    </div>

                                    <h5>Payment Method</h5>

                                    <div class="form-group">
                                        <!-- <label for="payment-method">Payment Method</label> -->
                                        <div class="form-check">
                                            <input
                                                type="radio"

                                                id="paymentMethodCard"
                                                name="paymentMethod"

                                                value="card"

                                                class="form-check-input"

                                                v-model="payment_method"

                                                checked
                                            >
                                            <label class="form-check-label" for="paymentMethodCard">
                                                Card
                                            </label>
                                        </div>

                                        <div v-if="payment_method == 'card' && cartContainsOnlyPublications">
                                            <div class="alert alert-primary mb-3" role="alert" v-if="!isHomeschoolStore">
                                                1 time payment of {{total | currency}} for a {{multiyear}} year subscription
                                            </div>
                                            <div class="alert alert-primary mb-3" role="alert" v-else>
                                                Payment of {{total | currency}} for a {{multiyear}} year homeschool subscription
                                            </div>
                                        </div>

                                        <div class="form-check">
                                            <input
                                                type="radio"

                                                id="paymentMethodPurchaseOrder"
                                                name="paymentMethod"

                                                value="purchase_order"

                                                class="form-check-input"

                                                v-model="payment_method"
                                            >
                                            <label class="form-check-label" for="paymentMethodPurchaseOrder">
                                                Purchase Order
                                            </label>
                                        </div>

                                        <div v-if="payment_method == 'purchase_order' && cartContainsOnlyPublications">
                                            <div class="alert alert-primary mb-3" role="alert" v-if="!isHomeschoolStore">
                                                1 time payment of {{total | currency}} for a {{multiyear}} year subscription
                                            </div>
                                            <div class="alert alert-primary mb-3" role="alert" v-else>
                                                Payment of {{total | currency}} for a {{multiyear}} year homeschool subscription
                                            </div>
                                        </div>

                                        <!--                                            <div class="form-check" v-if="shouldShowPaymentPlanOption()">-->
                                        <!--                                                <input-->
                                        <!--                                                    type="radio"-->

                                        <!--                                                    id="paymentMethodPlan"-->
                                        <!--                                                    name="paymentMethod"-->

                                        <!--                                                    value="plan"-->

                                        <!--                                                    class="form-check-input"-->

                                        <!--                                                    v-model="payment_method"-->
                                        <!--                                                >-->
                                        <!--                                                <label class="form-check-label" for="paymentMethodPlan">-->
                                        <!--                                                    Payment Plan-->
                                        <!--                                                </label>-->
                                        <!--                                            </div>-->
                                    </div>

                                    <div v-if="payment_method == 'card' || (payment_method == 'plan' && shouldShowPaymentPlanOption())">
                                        <template v-if="payment_method == 'plan'">
                                            <div class="form-group">
                                                <select
                                                    class="form-control"
                                                    v-model="subscription_duration"
                                                >
                                                    <option value="3">3 Months</option>
                                                    <option value="6">6 Months</option>
                                                    <!--                                                        <option value="12">12 Months</option>-->
                                                </select>
                                            </div>
                                            <div class="alert alert-primary mb-3" role="alert" >
                                                By choosing this option you agree to make {{subscription_duration}} monthly payments of {{payment_plan_amount | currency}}
                                            </div>
                                        </template>


                                        <!--                                            <iframe v-if="formToken" :src="`https://accept.authorize.net/payment/payment?=${formToken}`">-->

                                        <!--                                            </iframe>-->
                                    </div>

                                    <div v-if="payment_method == 'purchase_order'">

                                        <div class="form-group" v-if="false">
                                            <b-form-file v-model="po_upload" accept=".pdf"
                                                         :state="validating && !po_upload ? false : null"
                                                         :class="{'is-invalid': validating && !po_upload}"
                                                         @input="validatePOUpload"
                                                         ref="poUpload">
                                            </b-form-file>
                                        </div>
                                        <div
                                            class="form-group"
                                            :class="{'mb-0': address_type !== 'custom'}"
                                        >
                                            <label for="purchase_order_number">Purchase Order Number *</label>
                                            <input
                                                type="text"

                                                ref="purchaseOrderNumber"

                                                class="form-control"
                                                :class="{'is-invalid': validating && !billing.purchase_order}"

                                                v-model="billing.purchase_order"
                                            >
                                            <div class="invalid-feedback">
                                                Purchase Order Number is required
                                            </div>
                                        </div>

                                        <div v-if="address_type == 'custom'" class="form-group mb-0">
                                            <label for="homeschool-association">
                                                Homeschool Association *
                                            </label>
                                            <select
                                                ref="shippingSchoolAssociation"

                                                class="form-control"
                                                :class="{'is-invalid': validating && !shipping.school.association}"

                                                v-model="shipping.school.association"
                                                @input="$bvModal.show('po_verification_modal')"
                                            >
                                                <option v-for="(charter, i) in charterSchools"
                                                        :key="`charter_${i}`"
                                                        :value="charter.company_id"
                                                >{{charter.company_name}}</option>

                                                <!-- old list -->
                                                <!--                                                    <option value="97628">Compass Charter Schools</option>-->
                                                <!--                                                    <option value="92804">Epic Charter School</option>-->
                                                <!--                                                    <option value="29348">Elite Academic Academy</option>-->
                                                <!--                                                    <option value="194392">Granite Mountain Charter School</option>-->
                                                <!--                                                    <option value="118763">iLead Exploration Independent Study</option>-->
                                                <!--                                                    <option value="135276">Inspire Charter Schools</option>-->
                                                <!--                                                    <option value="194216">Inspire South Schools</option>-->
                                                <!--                                                    <option value="29422">Visions in Education</option>-->
                                            </select>
                                            <div class="invalid-feedback">
                                                Homeschool Association is required
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="card-body border-top" v-if="!isHomeschoolStore">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-group mb-lg-0">
                                                <label for="billing_email">Billing Email*</label>
                                                <b-input
                                                    type="email"

                                                    ref="invoiceEmail"
                                                    class="form-control"
                                                    :class="{'is-invalid': validInvoiceEmail}"

                                                    v-model="invoiceEmail"
                                                />
                                                <div class="invalid-feedback">
                                                    Billing Email is required
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-group mb-0">
                                                <label for="billing_phone">Billing Phone*</label>
                                                <input
                                                    type="tel"

                                                    ref="invoicePhone"

                                                    class="form-control"
                                                    :class="{'is-invalid': validInvoicePhone}"

                                                    v-model="invoicePhone"
                                                    @blur="invoicePhone = sanitizePhone(invoicePhone)"
                                                >
                                                <div class="invalid-feedback">
                                                    Please enter a valid phone number
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer bg-white py-3">
                                    <h5>Billing Address</h5>

                                    <div class="form-group mb-0">
                                        <div class="form-check">
                                            <b-checkbox
                                                type="checkbox"
                                                id="billingAddressSame"
                                                v-show="!isReadOnly"
                                                class="form-check-input"

                                                v-model="billing_address_same"
                                                :disabled="isReadOnly"
                                            >
                                                Billing Address is the same as Shipping Address
                                            </b-checkbox>
                                        </div>
                                    </div>

                                    <div v-show="billing_address_same" class="text-muted mt-3">
                                        <div>{{shipping.first_name}} {{shipping.last_name}}</div>
                                        <div v-if="isHomeschoolStore">{{shipping.email}} <span v-if="shipping.school.phone">| {{shipping.school.phone}}</span></div>
                                        <div v-if="!isHomeschoolStore">{{shipping.school.name}}</div>
                                        <div>{{shipping.school.address}}</div>
                                        <div><span v-if="shipping.school && shipping.school.city && shipping.school.state">{{shipping.school.city}}, {{shipping.school.state}}</span> {{shipping.school.zip}}</div>
                                    </div>

                                    <div v-show="!billing_address_same" class="mt-3">
                                        <div class="row mb-2" v-if="isHomeschoolStore">
                                            <div class="col-lg-6">
                                                <div class="form-group mb-lg-0">
                                                    <label for="billing_email">Billing Email*</label>
                                                    <b-input
                                                        type="email"

                                                        ref="invoiceEmail"

                                                        class="form-control"
                                                        :class="{'is-invalid': validInvoiceEmail}"

                                                        v-model="invoiceEmail"
                                                        :disabled="isReadOnly"
                                                    />
                                                    <div class="invalid-feedback">
                                                        Billing Email is required
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-group mb-0">
                                                    <label for="billing_phone">Billing Phone*</label>
                                                    <input
                                                        type="tel"

                                                        ref="invoicePhone"

                                                        class="form-control"
                                                        :class="{'is-invalid': validInvoicePhone}"

                                                        v-model="invoicePhone"
                                                        :disabled="isReadOnly"
                                                        @blur="invoicePhone = sanitizePhone(invoicePhone)"
                                                    >
                                                    <div class="invalid-feedback">
                                                        Please enter a valid phone number
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <label for="first_name">Billing First Name *</label>
                                                    <input
                                                        type="text"

                                                        ref="billingFirstName"

                                                        class="form-control"
                                                        :class="{'is-invalid': validating && !billing.first_name}"

                                                        v-model="billing.first_name"
                                                        :disabled="isReadOnly"
                                                    >
                                                    <div class="invalid-feedback">
                                                        First Name is required
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <label for="last_name">Billing Last Name *</label>
                                                    <input
                                                        type="text"

                                                        ref="billingLastName"

                                                        class="form-control"
                                                        :class="{'is-invalid': validating && !billing.last_name}"

                                                        v-model="billing.last_name"
                                                        :disabled="isReadOnly"
                                                    >
                                                    <div class="invalid-feedback">
                                                        Last Name is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="billing-address-type">Billing Address Type</label>
                                            <div class="form-check">
                                                <input
                                                    type="radio"

                                                    id="billingAddressTypeSchool"
                                                    name="addressTypeBilling"

                                                    value="school"

                                                    class="form-check-input"

                                                    v-model="billing_address_type"
                                                    :disabled="isReadOnly"

                                                    @change="copyBillingSchool"

                                                    checked
                                                >
                                                <label class="form-check-label" for="billingAddressTypeSchool">
                                                    School
                                                </label>
                                            </div>
                                            <div class="form-check">
                                                <input
                                                    type="radio"

                                                    id="billingAddressTypeCustom"
                                                    name="addressTypeBilling"

                                                    value="custom"

                                                    class="form-check-input"

                                                    v-model="billing_address_type"
                                                    @change="copyBillingSchool"
                                                    :disabled="isReadOnly"
                                                >
                                                <label class="form-check-label" for="billingAddressTypeCustom">
                                                    Homeschool/Custom
                                                </label>
                                            </div>
                                        </div>

                                        <div v-if="billing_address_type == 'school'" class="mb-3">
                                            <div class="form-group mb-0">
                                                <label for="billing_school_search">Find School To Bill To*</label>
                                                <span class="loader" v-show="isLoading"></span>
                                                <multiselect
                                                    ref="billingSchoolSearch"

                                                    :class="{'is-invalid': validating && !billing_school_search}"

                                                    placeholder="Search by Zip Code"

                                                    v-model="billing_school_search"

                                                    :options="billing_schools"

                                                    track-by="name"
                                                    label="name"
                                                    :searchable="true"
                                                    :loading="isLoading"
                                                    :internal-search="false"
                                                    @search-change="searchBillingSchools"
                                                    @select="setBillingSchool"
                                                    @remove="unsetBillingSchool"
                                                    :disabled="isReadOnly"
                                                >
                                                </multiselect>
                                                <div class="invalid-feedback">
                                                    Please find and select a school
                                                </div>
                                            </div>
                                            <div v-if="billing.id" class="text-muted mt-3">
                                                <div>{{billing.first_name}} {{billing.last_name}}</div>
                                                <div>{{billing.school}}</div>
                                                <div>{{billing.address}}</div>
                                                <div>{{billing.city}}, {{billing.state}} {{billing.zip}}</div>
                                            </div>

                                        </div>

                                        <div v-show="billing_address_type !== 'school'" class="my-3">
                                            <div class="form-group">
                                                <label for="school_name">Homeschool / School Name To Bill To*</label>
                                                <input
                                                    type="text"

                                                    ref="billingSchoolName"

                                                    class="form-control"
                                                    :class="{'is-invalid': validating && !billing.school}"

                                                    v-model="billing.school"
                                                    :disabled="isReadOnly"
                                                >
                                                <div class="invalid-feedback">
                                                    Homeschool / School Name
                                                </div>
                                            </div>

                                            <AddressForm v-model="billing"
                                                         :form-validated="validating"
                                                         label="Billing"
                                                         :disabled="isReadOnly"
                                                         :validate="false"
                                                         ref="billingAddressForm"/>

                                        </div>

                                        <!-- <div class="form-group mb-0">
                                            <label for="school_phone">Phone Number</label>
                                            <input
                                                type="tel"

                                                ref="billingPhone"

                                                class="form-control"

                                                v-model="billing.phone"
                                            >
                                        </div> -->
                                    </div>

                                    <div class="text-warning mt-3">
                                        <small>
                                            * denotes required fields
                                        </small>
                                    </div>
                                </div>
                            </div>
                            </fieldset>
                        </form>
                        <!-- Payment Frame -->
                        <div v-show="showPaymentPage">
                            <div ref="iframe_container" v-show="token">
                                <div ref="iframe_holder" class="center-block">
                                    <iframe id="add_payment"
                                            name="add_payment"
                                            ref="add_payment"
                                            v-show="displayForm"
                                            class="embed-responsive-item panel"
                                            width="100%" frameborder="0" scrolling="no" style="min-height:1200px; height: 100vh;">
                                    </iframe>
                                </div>
                                <form id="send_token" ref="send_token" action="" method="post" target="add_payment">
                                    <input ref="token_input" type="hidden" name="token" :value="token" />
                                </form>
                            </div>
                        </div>
                        <div v-show="errorMessage" style="color:red; text-align: center" v-html="errorMessage">
                        </div>
                    </div>
                    <!-- OrderDetails Summary / Right Side -->
                    <div class="col-xl-4">
                        <div v-sticky="{ zIndex: 10, stickyTop: 130}">
                            <div class="card mt-xl-0 mt-3">
                                <h5 class="card-header">
                                    <font-awesome-icon :icon="['fad', 'list-alt']" class="text-warning" fixed-width /> Order Summary
                                </h5>
                                <!-- <div class="card-body">
                                    {{products}}
                                </div> -->
                                <b-container
                                    class=" products"
                                    :class="{'lg': products.length >= 3}"
                                >
                                    <template v-for="(product, i) in products"  class="">
                                    <b-row>
                                        <!-- Top Row: icon & title-->
                                        <!-- Icon -->
                                        <b-col cols="2">
                                            <img v-if="product.cover"
                                                :src="'//cdn.studiesweekly.com/' + product.cover"
                                                alt=""
                                                class="rounded"
                                            >
                                            <img v-else-if="product.thumbnail"
                                                :src="product.thumbnail"
                                                 alt=""
                                                class="rounded"
                                            >
                                        </b-col>
                                        <!-- Title -->
                                        <b-col>
                                            <h6 class="mb-1">
                                                <div v-if="product.title">{{product.title}}</div>
                                                <div v-if="!product.title && product.name">{{product.name}}</div>
                                            </h6>
                                        </b-col>
                                    </b-row>
                                    <!-- Second Row: sku details & Price -->
                                    <b-row>
                                        <!-- Details -->
                                        <b-col cols="9">
                                            <div class="">
                                                <small v-if="product.format">
                                                    <span class="text-muted" v-if="!isHomeschoolStore">1 payment for a {{multiyear}} year subscription</span>
                                                    <span class="text-muted" v-else>Payment for a 1 year homeschool subscription</span>
                                                </small>
                                                <br/>
                                                <small>
                                                    <span class="text-muted">Qty. {{product.quantity}}</span>
                                                    &nbsp;|&nbsp;
                                                    <span class="text-muted">State: {{formattedState(product.state)}}</span>
                                                    &nbsp;|&nbsp;
                                                    <span class="text-muted">Grade:
                                                        <template v-if="product.grade == '-1'">PreK</template>
                                                        <template v-else-if="product.grade == '0'">K</template>
                                                        <template v-else>{{product.grade}}</template>
                                                    </span>
                                                    &nbsp;|&nbsp;
                                                    <span class="text-muted">Subject: {{product.topic}}</span>
                                                </small>
                                                <div
                                                    :class="{'d-flex': products.length > 3}"
                                                >
                                                    <div v-if="product.format">
                                                        <b-btn variant="link" size="sm" :id="`cart_details_btn_${i}`" @click.prevent>
                                                            Details
                                                        </b-btn>
                                                        <b-popover :target="`cart_details_btn_${i}`" triggers="hover" placement="left" custom-class="bg-dark">
                                                            <div class="text-left text-white">
                                                                <div>
                                                                    State: {{formattedState(product.state)}}
                                                                </div>
                                                                <div>
                                                                    Subject: {{product.topic}}
                                                                </div>
                                                                <div>
                                                                    Grade:
                                                                    <template v-if="product.grade == '0'">K</template>
                                                                    <template v-else>{{product.grade}}</template>
                                                                </div>
                                                                <div>
                                                                    Language:
                                                                    <template v-if="product.language == 'en'">
                                                                        <!-- <span class="flag-icon flag-icon-us mx-1"></span>--> English
                                                                    </template>
                                                                    <template v-else-if="product.language == 'es'">
                                                                        <!-- <span class="flag-icon flag-icon-es mx-1"></span>--> Spanish
                                                                    </template>
                                                                    <template v-else>{{product.language}}</template>
                                                                </div>
                                                                <div>
                                                                    Format:
                                                                    <template v-if="product.format == 'print_online'">print &amp; online</template>
                                                                    <template v-else-if="product.format == 'online_only'">online only</template>
                                                                    <template v-else>{{product.format}}</template>
                                                                </div>
                                                                <div>
                                                                    Type:
                                                                    {{product.type}}
                                                                </div>
                                                            </div>
                                                        </b-popover>

                                                    </div>

                                                </div>

                                            </div>
                                        </b-col>
                                        <!-- Price -->
                                        <b-col>
                                            <div class="align-self-center ml-auto text-right">
                                                <div class="text-nowrap" v-if="product.price">
                                                    {{product.quantity * product.price | currency}}
                                                </div>
                                                <div class="text-nowrap" v-else-if="product.format">
                                                    {{product.quantity * price(product.prices, product.format, product.type, product.quantity, 1).yearstotal * multiyear | currency}}
                                                </div>
                                                <div class="text-nowrap" v-else>
                                                    {{product.quantity * product.price | currency}}
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    </template>
                                </b-container>
                                <div class="card-footer py-2 border-top-0">
                                    <div class="d-flex">
                                        <div>
                                            <label class="text-muted mr-2 mb-0">Subtotal</label>
                                        </div>
                                        <div class="ml-auto">
                                            {{subtotal | currency}}
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer py-2" v-for="(discount, i) in discounts" :key="`discount_${i}`">
                                    <div class="d-flex">
                                        <div>
                                            <label class="text-muted mr-2 mb-0 font-weight-bold">
                                                {{discount.label}}
                                            </label>
                                        </div>
                                        <div class="ml-auto text-danger">
                                            - {{discount.discount_amount | currency}}
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer py-2">
                                    <div class="d-flex">
                                        <div>
                                            <label class="text-muted mr-2 mb-0">Shipping</label>
                                        </div>
                                        <div class="ml-auto">
                                            <span v-if="shippingCost && shippingCost > 0">{{shippingCost | currency}}</span>
                                            <span class="text-success" v-else-if="shipping.school.zip && shippingCost == 0">Free</span>
                                            <span class="text-muted" v-else>Pending</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="taxrate > 0 || totalTax > 0" class="card-footer py-2">
                                    <div class="d-flex">
                                        <div>
                                            <label class="text-muted mr-2 mb-0">Tax</label>
                                        </div>
                                        <div class="ml-auto">
                                            <span>{{totalTax | currency}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="cardFee > 0" class="card-footer py-2">
                                    <div class="d-flex">
                                        <div>
                                            <label class="text-muted mr-2 mb-0">Processing Fee</label>
                                        </div>
                                        <div class="ml-auto">
                                            <span>{{cardFee | currency}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer py-2">
                                    <div class="d-flex">
                                        <div>
                                            <label class="text-muted mr-2 mb-0">Total</label>
                                        </div>
                                        <div class="ml-auto">
                                            <strong>{{total | currency}}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="my-3">

                                <div v-if="false" class="form-check">
                                    <input
                                        type="checkbox"

                                        id="specialOffersCheck"

                                        value=""

                                        class="form-check-input"

                                        v-model="special_offers"
                                    >
                                    <label class="form-check-label" for="specialOffersCheck">
                                        Please send me Special Offers
                                    </label>
                                </div>

                                <div v-if="false" class="form-check">
                                    <input
                                        type="checkbox"

                                        id="teachingTipsCheck"

                                        value=""

                                        class="form-check-input"

                                        v-model="teaching_tips"
                                    >
                                    <label class="form-check-label" for="teachingTipsCheck">
                                        Please send me Teaching Tips
                                    </label>
                                </div>
                            </div>
                            <b-card class="mb-1 p-0">
                                <b-btn :variant="tosButtonVariant" class="p-0 m-0">
                                    <b-checkbox required name="accept_tos" v-model="acceptTos">
                                        I have read and agreed to the <b-btn class="p-0 m-0" variant="link" v-b-modal="'tos_modal'">Terms & Conditions</b-btn>.
                                    </b-checkbox>
                                </b-btn>

                            </b-card>
                            <b-card class="mb-3 p-0" v-if="isHomeschoolStore">
                                <b-btn :variant="homeschoolButtonVariant" class="p-0 m-0">
                                    <b-checkbox required name="accept_tos" v-model="acceptHomeschoolAgreement">
                                        I affirm that this order is solely for homeschool use and not for use in a traditional school or classroom setting.
                                    </b-checkbox>
                                </b-btn>

                            </b-card>

                            <button
                                v-show="!displayForm"
                                type="submit"
                                @click="checkout"
                                class="btn btn-lg btn-success w-100"
                                :class="{'disabled': total >= 5000}"

                                :disabled="total >= 5000 || placingOrder || !products.length"
                            > <!-- do not allow submitting an order that exceeds $5000 TODO: show a message here-->
                                <div v-if="placingOrder">
                                    <font-awesome-icon :icon="['fad', 'circle-notch']" spin />
                                </div>
                                <div v-else-if="payment_method == 'card'">
                                    Continue to Payment
                                </div>
                                <div v-else>
                                    Place Order
                                </div>
                            </button>
                        </div>
                    </div>
                </div>


                <!-- <div class="d-flex">
                    <div class="ml-auto">
                        <button
                            type="submit"

                            class="btn btn-success w-100"
                        >
                            Confirm OrderDetails
                        </button>
                    </div>
                </div> -->

                <!-- <button
                        type="submit"

                        class="btn btn-lg btn-success w-100 mt-3"
                >
                    Place OrderDetails
                </button> -->

            </div>
        </section>
        <b-modal id="po_upload_modal" no-close-on-backdrop no-close-on-esc hide-footer hide-header-close>
            <div class="loader" style="min-width: 50px; min-height:50px;"></div>Uploading Purchase Order...
        </b-modal>
        <b-modal id="po_verification_modal" title="Homeschool Associations" :ok-disabled="!poAuthConfirmed" no-close-on-backdrop no-close-on-esc hide-header-close>
            <p>Only school personnel are authorized to place orders for this organization.</p>
            <p>Please contact the school if you are a parent or guardian of a student.</p>
            <b-form-checkbox id="po_auth_checkbox" v-model="poAuthConfirmed" value="1" unchecked-value="0">I am authorized to place this order.</b-form-checkbox>
        </b-modal>
        <b-modal id="tos_modal" title="Terms & Conditions" size="lg" ok-title="I Agree" @ok="acceptTOS()">
            <div style="font-family:'Open Sans';font-weight:normal;color:#000000;">
                <h2>Studies Weekly Payment Terms</h2>
                <p>The upcoming school year curriculum payment is due September 1 unless the order is placed after August 1. Those later orders are Net 30. Homeschool and other orders not sent to a school district require full payment before shipment.</p>
                <p>&nbsp;</p>
                <h2>Duplicate Orders</h2>
                <p>
                    <span style="font-weight: 400;">Studies Weekly is not responsible for duplicate orders. Duplicates may occur when an order is sent in separately from a PO, creating the appearance of two unique orders. To avoid such confusion, please send your order and PO </span><span style="font-weight: 400;">together</span><span style="font-weight: 400;">. If you notice that your order has been duplicated, please contact Customer Service at (866) 311-8734 to cancel the duplicate order and arrange for a return, if necessary. Please see our return policy for further details.</span>
                </p>
                <p>&nbsp;</p>
                <h2>Studies Weekly Return Policy</h2>
                <p>
                    <span style="font-weight: 400;">Orders can be canceled prior to shipment by contacting our Customer Support department as soon as possible. For any orders that have shipped, the items must be received back with an included RMA (Return Material Authorization) and the return must be processed by a Studies Weekly agent before a refund can be provided.</span>
                </p>
                <p>
                    <span style="font-weight: 400;">Studies Weekly will gladly accept a return under the following conditions:</span>
                </p>
                <ul>
                    <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Contact the Customer Support department to request a Return Material Authorization (RMA) within a valid return window.</span>
                        <ul><li style="font-weight: 400;" aria-level="2"><span style="font-weight: 400;">Pre-orders have until Oct. 31st.</span></li>
                            <li style="font-weight: 400;" aria-level="2"><span style="font-weight: 400;">Standard order have 60 days from the date of purchase.</span></li>
                        </ul>
                    </li>
                    <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">RMAs are valid for 30 days and the return must be received within the 30 day window.</span>
                        <ul><li style="font-weight: 400;" aria-level="2"><span style="font-weight: 400;">No RMAs will be issued after January 30th of the current school year.</span></li>
                            <li style="font-weight: 400;" aria-level="2"><span style="font-weight: 400;">No refunds will be given for orders received after the RMA expires.</span></li>
                        </ul>
                    </li>
                    <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">The customer is responsible for all return shipping costs.</span></li>
                    <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Products must be returned unused, unseparated, undamaged, and in their original condition.</span>
                        <ul><li style="font-weight: 400;" aria-level="2"><span style="font-weight: 400;">Damaged or incomplete products are not eligible for a refund.</span></li>
                        </ul>
                    </li>
                    <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">A restocking fee will be applied to each classroom box returned.</span>
                        <ul><li style="font-weight: 400;" aria-level="2"><span style="font-weight: 400;">The restocking fee is $10.00.</span></li>
                            <li style="font-weight: 400;" aria-level="2"><span style="font-weight: 400;">The restocking fee is subtracted from the total refundable amount.</span></li>
                            <li style="font-weight: 400;" aria-level="2"><span style="font-weight: 400;">If there is not a refundable amount, the customer is still responsible for the restocking fee.</span></li>
                        </ul>
                    </li>
                    <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Refunds are only available up to 60 days after the date of purchase or before October 31 of the order year.</span></li>
                </ul>
                <p>&nbsp;</p>
                <h2>Studies Weekly Shipping Policy</h2>
                <p><span style="font-weight: 400;">Shipping for the new school year begins in April, and product is shipped within a mutually agreed upon shipping window, based on customer availability to receive and sign for delivery. Please note:</span></p>
                <ul><li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">The shipping carrier is typically FedEx or Freight and is determined by order details.&nbsp;</span></li>
                    <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Products can be expected to arrive within 14 days of shipping.&nbsp;</span></li>
                    <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Studies Weekly is not responsible for delayed delivery of product due to backorder, acts of nature, carrier problems or other unforeseeable issues.</span></li>
                    <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Publications that are delivered damaged or lost in shipment will be replaced at no additional cost.</span></li>
                    <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Please allow 3-4 weeks for shipping to Hawaii and Alaska.</span></li>
                </ul>
                <p></p>
            </div>
        </b-modal>
        <Footer />
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";
.products {
    img {
        width: 40px;
    }
}

.loader {
    display: inline-block;
    margin-top: 5px;
    margin-left: 5px;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 15px;
    height: 15px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
}
@-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
#ship_partial {
    color: green;
}
#ship_partial:hover {
    cursor: pointer;
}

.date-label:hover {
    cursor: pointer !important;
    border: 1px solid deepskyblue;
}
#address_validation.invalid {
    border: 1px solid darkred;
}

.disabled-year-msg {
    color: red;
}



@media (min-width: 992px) {
    .products.lg {
        max-height: 300px;
        overflow: auto;
        img {
            width: 30px;
        }
        h6, .h6 {
            font-size: .8rem;
        }
    }

    .products::-webkit-scrollbar {
        -webkit-appearance: none;
    }

    .products::-webkit-scrollbar:vertical {
        width: 11px;
    }

    .products::-webkit-scrollbar:horizontal {
        height: 11px;
    }

    .products::-webkit-scrollbar-thumb {
        border-radius: 8px;
        border: 2px solid white; /* should match background, can't be transparent */
        background-color: rgba(0, 0, 0, .5);
    }
}

.is-invalid .vc-border {
    border-color: $danger;
}

/* .vc-day-content[data-v-47ef1cd6]:focus {
    background-color: transparent;
} */
</style>

<style lang="scss">
@import "@/assets/scss/_colors.scss";

.captcha-invalid > div > div{
    border-width: 1px;
    border-style: solid;
    border-color: $danger;
}
.multiselect.is-invalid .multiselect__tags {
    border-color: $danger;
}

.multiselect.is-invalid ~ .invalid-feedback {
    display: block;
}
</style>

<script>
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

import moment from 'moment'

Vue.use(require('vue-moment'))

import { mapState, mapGetters } from 'vuex'

import Cleave from 'vue-cleave'



import product_prices from '@/common/product_prices'
import states_disallow_discount_codes from '@/common/states_disallow_discount_codes'
import {EARLY24_BLOCKED_STATES, STORE_ALLOWED_DISCOUNT_CODES} from '@/common/states_disallow_discount_codes'
import {shippingStates, publicationStates} from '@/common/states'
import multiyear_options from '@/common/multiyear_options'

import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import TempAvailabilityMessage from "@/components/TempAvailabilityMessage";
import {productPricesOfFormat} from "@/common/utils";
import VueRecaptcha from 'vue-recaptcha';
import AddressForm from "@/components/checkout/AddressForm";
import OrderSummary from "@/components/checkout/OrderSummary";
import VueSticky from "vue-sticky";
// TODO: read this url from .env file
const FRAME_URL = `${process.env.VUE_APP_AUTHNET_URL}`;

export default {
    name: 'dashboard',
    data: () => ({
        dontFetchPrices: false,
        hasUploadedPO: false,
        acceptTos: false,
        acceptHomeschoolAgreement: false,
        showTOSAlert: false,
        showHomeschoolAlert: false,
        disableTos: true,
        poAuthConfirmed: 0,
        errorMessage: null,
        token: null,
        displayForm: false,
        cartData: {},
        products: [],
        orderId: null,
        transactionId: null,
        transaction: {},
        showPaymentPage: false,
        formToken: null,
        testing: process.env.VUE_APP_ENV !== 'production',
        needs_shipping_address: false,
        blackoutWindows: [],
        blackoutNoWindows: false,

        // Captcha
        siteKey: "6LdehAYbAAAAANGcxDvwIkv6qA9r8gPtcK4-r5q1", // Production
        // siteKey: "6LczvvkaAAAAAJjmEVOlt3P5_j8wMd3v8g4YHqvF", // Local (Move to ENV)

        captchaInvalid: false,

        // Imports
        product_prices: product_prices,
        states: shippingStates,
        publicationStates: publicationStates,
        multiyear_options: multiyear_options,
        charterSchools: [],

        schools: [],
        billing_schools: [],
        subscription_duration: 6,

        address_type: "school",
        billing_address_type: "school",
        payment_method: "card",
        po_upload: null,
        po_filename: "",

        now: new Date(),
        current_year: new Date().getFullYear(),
        current_month: new Date().getMonth() + 1, // January is 0, February is 1, etc.

        // current_month: 9,

        school_search: null,

        billing_school_search: null,

        sweepstakes_code: null,
        discount_code: null,
        discount_code_type: 'full-cart-excluding-online-only',
        discount_code_single_product_sku: null,
        states_disallow_discount_codes: states_disallow_discount_codes,

        shipping: {
            school: {
                address: "",
                city: "",
                state: "",
                zip: ""
            },
            arrive_window: {},
            canShipPartial: false,
            cantShipPartial: false,
        },
        openday: null,
        ship_together: 0,

        shippingCost: null,
        billing: {},

        invoiceEmail: null,
        invoicePhone: null,
        shippingEmail: null,

        taxrate: 0,
        totalTax: 0,

        cardFee: 0,

        card: {},

        shippingAddressValidated: false,
        shippingAddressStatus: 0,
        shippingAddressAccepted: false,

        applyingSweepstakesCode: false,
        invalidSweepstakesCode: false,

        applyingDiscountCode: false,
        invalidDiscountCode: false,

        special_offers: true,
        teaching_tips: true,

        billing_address_same: true,
        isLoading: false,
        validating: false,
        arriveWindowRangeError: null,

        placingOrder: false,

        discount_by_topic: {},
        discounts: [],

        removeIconHover: 'text-gray',

        currentBundleDiscountCode: 'BUNDLE2020',
        currentBundleDiscount: 0.1,
        captchaToken: null,
    }),
    components: {
        OrderSummary,
        AddressForm,
        TempAvailabilityMessage,
        Cleave,
        Calendar,
        DatePicker,
        VueRecaptcha,
        Navbar,
        Footer
    },
    directives: {
        'sticky': VueSticky,
    },
    computed: {
        isQuoteConversion() {
            return this.quote != null;
        },
        showDiscountField() {
            if (this.isHomeschoolStore)
                return false;

            if (this.isReadOnly || this.isQuoteConversion)
                return this.discount_code != null;

            return true;
        },
        isReadOnly() {
            return this.placingOrder;
        },
        tosButtonVariant() {
            return this.showTOSAlert ? 'outline-danger' : 'text';
        },
        homeschoolButtonVariant() {
            return this.showHomeschoolAlert ? 'outline-danger' : 'text';
        },
        validInvoiceEmail() {
            return this.validating && (!this.invoiceEmail || !this.isValidEmail(this.invoiceEmail));
        },
        validShippingEmail() {
            return this.validating && (!this.shippingEmail || !this.isValidEmail(this.shippingEmail));
        },
        validInvoicePhone() {
            return this.validating && !this.isValidPhone(this.invoicePhone);
        },
        validShippingPhone() {
            return this.validating && this.isHomeschoolStore && !this.isValidPhone(this.shipping.school.phone);
        },
        shipPartialInvalid() {
            return this.validating && this.isHomeschoolStore && !this.shipping.canShipPartial && !this.shipping.cantShipPartial;
        },
        ...mapGetters(['showBothSchoolYears', 'multiyear', 'isHomeschoolStore']),
        ...mapState({
            selectedState: state => state.stateData.selectedState,
            selectedSchoolYear: state => state.stateData.selectedYear,
            saved_sweepstakes_code: state => state.checkout.saved_sweepstakes_code,
            saved_discount_code: state => state.checkout.saved_discount_code,
            affiliate: state => state.affiliate,
            credentials: state => state.checkout.credentials,

            cart: state => state.cart,
            quote: state => state.checkout.quoteData,
            discount: state => {
                if(state.checkout.discount){
                    return state.checkout.discount
                }
                return false
            },
            sweepstakes: state => state.checkout.sweepstakes
        }),
        ...mapGetters ({
            schoolYear: 'getCurrentSchoolYear',
        }),
        multiyear_selected: {
            get () {
                return this.multiyear
            },
            set (multiyear_selected) {
                this.$store.commit('setMultiyearValue', multiyear_selected)
            }
        },
        user () {
            return this.$auth.user()
        },
        itemCount () {
            var itemcount = 0
            _.forEach(this.products, product => {
                itemcount = itemcount + product.quantity
            })
            return itemcount
        },
        subtotal () {
            var subtotal = []
            _.forEach(this.products, product => {
                var productTotal = null

                if (product.price)
                {
                    productTotal = (product.quantity * product.price)
                }
                else if (product.format) {
                    productTotal = (product.quantity * this.price(product.prices, product.format, product.type, product.quantity, 1).yearstotal)

                    productTotal = productTotal * this.multiyear
                }
                else {
                    productTotal = (product.quantity * product.price)
                }

                subtotal.push(productTotal)
            })

            return _.sum(subtotal)
        },
        subtotal_with_multiyear () {
            var subtotal_with_multiyear = []
            _.forEach(this.products, product => {
                var productTotal = null

                if(product.format) {
                    productTotal = (product.quantity * this.price(product.prices, product.format, product.type, product.quantity, this.multiyear).yearstotal)
                }
                else {
                    productTotal = (product.quantity * product.price)
                }

                subtotal_with_multiyear.push(productTotal)
            })

            return _.sum(subtotal_with_multiyear)
        },
        total () {
            let total = this.subtotal + this.shippingCost + this.totalTax + this.cardFee;
            for (let i = 0; i < this.discounts.length; ++i) {
                total -= this.discounts[i].discount_amount;
            }
            return total.toFixed(2);
            // return this.subtotal - (this.discount_amount_for_multiyear + this.discount_amount_for_discountcode) + this.shippingCost + this.totalTax
        },
        payment_plan_amount () {
            return Math.floor((this.total * 100)/this.subscription_duration)/100;
        },
        minDate () {
            // Return 1 week from today (2 weeks instead?)
            let today = new Date();
            return today.setDate(today.getDate() + 7);
        },
        maxDate () {
            var maxDate = null

            maxDate = new Date(this.current_year+1, "8", "30") // September 30th

            return maxDate
        },
        cartContainsOnlyPublications () {
            let value = true

            _.forEach(this.products, product => {

                if(product.burrito) {
                    value = false
                }
            })

            //Might Be A Better User Experience, but for now we will leave it.
            //if(value == false) {
                //Reset Multi-Year Option to 1
                //this.$store.commit('setMultiyearValue', multiyear_options[0])
            //}

            return value
        },
        productsById() {
            return this.products.reduce((acc, product) => {
                acc[product.legacy_id] = product;
                return acc;
            }, {});
        }
    },
    beforeRouteLeave (to, from, next) {
        if (
            to.name == 'checkoutSuccess' ||
            to.name == 'login' ||
            to.name == 'acceptPayment'
        ) {
            next()
        } else {
            if (_.some(this.shipping) || _.some(this.billing)) {
                this.$swal({
                    text: "Are you sure you want to leave the Checkout page?",
                    showCancelButton: true,
                    confirmButtonText: 'Leave Checkout',
                    confirmButtonClass: 'btn btn-warning',
                    cancelButtonText: 'Cancel',
                    cancelButtonClass: 'btn btn-light',
                    buttonsStyling: false,
                    reverseButtons: true
                }).then((willLeaveCheckout) => {
                    if (willLeaveCheckout.value) {
                        next()
                    }
                    this.$store.commit('setQuote', null)
                })
            }
        }
    },
    watch: {
        acceptTos() {
            this.showTOSAlert = !this.acceptTos;
        },
        acceptHomeschoolAgreement() {
            this.showHomeschoolAlert = !this.acceptHomeschoolAgreement;
        },
        'shipping.canShipPartial': {
            handler (canShipPartial) {
                if (canShipPartial && this.shipping.cantShipPartial)
                    this.shipping.cantShipPartial = false;
            },
            deep: true
        },
        'shipping.cantShipPartial': {
            handler (cantShipPartial) {
                if (cantShipPartial && this.shipping.canShipPartial)
                    this.shipping.canShipPartial = false;
            },
            deep: true
        },
        shippingEmail(val) {
            this.shipping.email = val;
        },
        user: {
            handler (user) {
                if (user.email) {
                    this.shipping.email = user.email
                }
                if (user.phone) {
                    this.invoicePhone = this.sanitizePhone(user.phone)
                }
            },
            deep: true,
            immediate: true
        },
        payment_method: {
            handler (payment_method) {
                if (payment_method != 'purchase_order') {
                    this.billing.purchase_order = null
                }
            },
            deep: true
        },
        billing_address_same: {
            handler (billing_address_same) {
                if (billing_address_same) {
                    this.setBillingToShippingInfo()
                } else {
                    let po = this.billing.purchase_order
                    this.billing.purchase_order = po;
                }
            },
            deep: true
        },
        address_type: {
            handler (address_type) {
                if (this.billing_address_same && address_type == 'custom') {
                    this.setBillingToShippingInfo()
                }
            },
            deep: true
        },
        billing_address_type: {
            handler (billing_address_type) {
            },
            deep: true
        },
        discount_code: {
            handler (discount_code) {
                let grade = 0
                this.discount_code_type = this.getDiscountCodeType(discount_code)
                this.discount_code_single_product_sku = this.getDiscountCodeSingleProductSku(discount_code)

                if(this.discount_code_type == 'bundle-with-2nd-product') {
                    for(grade=0; grade<=8; grade++) {
                        this.discount_by_topic[grade]['Science']['en'] = 0
                        this.discount_by_topic[grade]['Science']['es'] = 0
                    }
                }
            },
            deep: true
        },
        'shipping.first_name': {
            handler (first_name) {
                if (this.billing_address_same) {
                    this.billing.first_name = _.cloneDeep(this.shipping.first_name)
                }
            }
        },
        'shipping.last_name': {
            handler (first_name) {
                if (this.billing_address_same) {
                    this.billing.last_name = _.cloneDeep(this.shipping.last_name)
                }
            }
        },
        'shipping.school': {
            handler (school) {
                if (this.billing_address_same) {
                    this.billing.name = this.shipping.school.name
                }

                // if (
                //     school.address &&
                //     school.city &&
                //     school.state &&
                //     school.zip
                // ) {
                //     this.validateShippingAddress()
                // }
            }
        },
        'shipping.school.zip': {
            handler (zip) {
                if (zip && zip.length < 5) return;

                this.getCartCosts(true).then(() => this.autoApplyCoupon());

            }
        },
        'shipping.school.state': {
            handler (state) {
                this.getCartCosts(true);

                // Has State changed?
                if (state == this.selectedState)
                    return

                // Should discount be removed?
                if (!this.discount_code || this.discount_code == 'BUNDLE2' || this.discount_code == 'BUNDLE3' || this.isDiscountAllowedForCurrentState(this.discount_code) == true)
                    return;

                this.clearDiscount_NoConfirm()

                setTimeout(() => {
                    this.$swal({
                        toast: true,
                        html: 'The discount code has been removed as it is not currently allowed in your state (' + this.get_current_selected_state() +').',
                        type: 'warning',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 5000
                    })

                }, 1000)
            }
        },
        'shipping.school_year': {
            handler (school_year) {
                if (school_year > this.schoolYear) {

                } else {
                    // this.shipping.fulfillment = 'asap'
                    // this.shipping.arrive_window = {}
                }
            },
        },
        'billing.zip': {
            handler (zip) {
                if (zip && zip.length < 5) return
            }
        }
    },
    filters: {
        percentage(val) {
            let floatVal = parseFloat(val);
            if (isNaN(floatVal))
                return val;

            return (floatVal * 100).toFixed(2);
        }
    },
    methods: {
        validatePOUpload() {

        },
        autoPopulateFromQuote(quote) {
            this.dontFetchPrices = true;
            console.log("Loading data from Quote", quote);
            // Form Data
            this.billing_address_type = 'custom';
            this.address_type = 'custom';


            // OrderDetails Data
            this.current_year = quote.school_year;
            this.billing_address_same = false;

            // Invoice Data
            // this.total = quote.subtotal;
            this.totalTax = quote.tax_total;
            this.shippingCost = quote.shipping_total;

            // Billing
            this.invoiceEmail = quote.billing.email;
            this.invoicePhone = this.sanitizePhone(quote.billing.phone);

            this.billing.name = quote.billing.name;
            let billingName = quote.billing.name;
            console.log("Billing Name:", billingName);

            this.setBillingSchool({
                name: quote.billing.name,
                company_id: quote.billing.company_id,
                id: quote.billing.company_id,
                pid: quote.billing.company_id,
                address: quote.billing.address,
                address2: quote.billing.address2,
                city: quote.billing.city,
                state: quote.billing.state,
                zip: quote.billing.zip,
            });
            this.billing.first_name =  billingName.substring(0, billingName.indexOf(' '));
            this.billing.last_name =  billingName.substring(billingName.indexOf(' ') + 1);
            this.billing.address = quote.billing.address;
            this.billing.address2 = quote.billing.address2;
            this.billing.city = quote.billing.city;
            this.billing.state = quote.billing.state;
            this.billing.zip = quote.billing.zip;

            // Shipping
            this.shipping.school.name = quote.shipping.name;

            let name = quote.shipping.name;
            this.shipping.first_name =  name.substring(0, name.indexOf(' '));
            this.shipping.last_name =  name.substring(name.indexOf(' ') + 1);
            this.shipping.phone = this.sanitizePhone(quote.shipping.phone);
            this.shipping.email = quote.shipping.email;
            this.shippingEmail = quote.shipping.email;


            let school = {
                name: quote.shipping.name,
                company_id: quote.shipping.company_id,
                id: quote.shipping.company_id,
                pid: quote.shipping.company_id,
                address: quote.shipping.address,
                address2: quote.shipping.address2,
                city: quote.shipping.city,
                state: quote.shipping.state,
                zip: quote.shipping.zip,
            }
            this.setSchool(school)

            this.shipping.canShipPartial = quote.can_ship_partial;
            this.shipping.cantShipPartial = quote.cant_ship_partial;
            this.shipping.school_year = quote.school_year;

            this.needs_shipping_address = false;
            this.school_search = {name: quote.shipping.zip};
            this.billing_school_search = {name: quote.billing.zip};
            this.openday = quote.openday;
            this.blackoutNoWindows = quote.no_shipping_restrictions == 1;

            // Shipping Locations
            for (let i = 0; i < quote.products.length; ++i) {
                quote.products[i].teachers = quote.products[i].classrooms;
                quote.products[i].custunitprice = quote.products[i].unitprice;
            }
            this.products = quote.products;

            // this.$nextTick()
            this.$forceUpdate();

        },
        isValidEmail(email) {
            if (!email)
                return false;
            // https://emailregex.com/ -- RFC 5322 Standard
            const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let match = email.match(emailRegex);
            return match != null;
        },
        sanitizePhone(phone) {
            if (!phone) return '';
            // Whitelist only characters valid in a phone number — digits, spaces, and
            // common formatting chars (+, -, (, ), ., x for extensions).
            // Anything else, including any Unicode formatting/control characters
            // (e.g. U+202A, zero-width spaces, etc.), is stripped.
            return phone.replace(/[^0-9\s\+\-\(\)\.xext]/gi, '').trim();
        },
        isValidPhone(phone) {
            if (!phone) return false;
            const sanitized = this.sanitizePhone(phone);
            // Must contain at least 7 digits to be a real phone number
            const digitsOnly = sanitized.replace(/\D/g, '');
            return digitsOnly.length >= 7;
        },
        acceptTOS() {
            this.acceptTos = true;
            this.showTOSAlert = false;
        },
        acceptHomeschoolAgreement() {
            this.acceptHomeschoolAgreement = true;
            this.showHomeschoolAlert = false;
        },
        validateAddress(addressIsValid, validatedStatus) {
            this.shippingAddressStatus = validatedStatus;
            this.shippingAddressAccepted = true;
        },
        shouldShowPaymentPlanOption() {
            return (
                !this.isHomeschoolStore
                && this.billing_address_type == 'school'
                && this.address_type === 'school');
        },
        getCharterSchools() {
            return this.$store.dispatch('getCharterSchools')
                .then((result) => {
                    this.charterSchools = result.data.sort((a,b) => {
                        return a.company_name.localeCompare(b.company_name);
                    });
                });
        },
        mergeWindows() {
            if (this.blackoutWindows.length === 0 || this.blackoutNoWindows)
                return [];

            let finalWindows = [];
            let windows = JSON.parse(JSON.stringify(this.blackoutWindows));
            // Sort by date ASC
            windows.sort((a, b) => {
                return new Date(a.start) - new Date(b.start);
            });

            // Check each window against the others, todo: figure out new algo for this.
            for (let i = 0; i < windows.length; ++i) {
                if (!windows[i].start || !windows[i].end)
                    continue;

                const windowA = windows[i];
                let newWindow = {start: new Date(windowA.start), end: new Date(windowA.end)};

                // Compare each date against the current window
                for (let j = 0; j < windows.length; ++j) {
                    if (j === i)
                        continue;

                    let windowB = {start: new Date(windows[j].start), end: new Date(windows[j].end)};

                    // A is not before B
                    if (newWindow.end > windowB.end)
                        continue;

                    // Date Diffs
                    const endToStartDiff = newWindow.end - windowB.start;
                    const endToStartDays = endToStartDiff / (1000 * 64 * 64 * 24);

                    // B is withing 2 weeks of A
                    if (endToStartDays > -13) {
                        newWindow.end = windowB.end;
                        windows.splice(j,1);
                        j--;
                    }
                }
                windows[i] = newWindow;
                finalWindows.push(newWindow);
            }
            return finalWindows;
        },
        addWindow() {
            this.blackoutWindows.push({start: null, end: null});
        },
        deleteWindow(i) {
            this.blackoutWindows.splice(i, 1);
        },
        toggleWindow(i) {
            let el =  this.$refs[`blackoutWindow_${i}`][0].$el;
            if (el.style.display !== 'none') {
                el.style = 'display: none';
                return;
            }
            el.style = 'display: block';
        },
        getDisabledDates(i) {
            // Get all items in blackoutWindows except the current (i-th) element
            return this.blackoutWindows.filter((element, index) => {
                return index !== i;
            });
        },
        dateRangeText(dateRange) {
            if (!dateRange || !dateRange.end)
                return null;

            let startDate = new Date(dateRange.start).toLocaleDateString('en-US');
            let endDate = new Date(dateRange.end).toLocaleDateString('en-US');

            return `${startDate} ~ ${endDate}`;
        },
        verifyCaptcha(response) {
            this.captchaToken = response;
            this.captchaInvalid = false;
        },
        expireCaptcha() {
            this.captchaToken = null;
            this.captchaInvalid = true;
        },
        errorCaptcha() {
            console.error("Captcha failed");
            this.captchaInvalid = true;
            this.$refs.captcha.reset();
        },
        async checkout () {

            let outageWindows = this.mergeWindows();

            // if all of the validation is not yet met or the subtotal exceeds $5000, do not allow checkout submit
            if (!this.validCheckout() || this.subtotal >= 5000) {
                return
            }


            // // Check captcha
            // if (this.captchaToken == null && !this.testing) {
            //     this.captchaInvalid = true;
            //     this.$swal({
            //         toast: true,
            //         html: "Please complete the ReCaptcha",
            //         type: 'error',
            //         position: 'top-end',
            //         showConfirmButton: false,
            //         timer: 5000
            //     });
            //     return;
            // } else {
            this.captchaInvalid = false;
            // }

            this.placingOrder = true

            if (this.invoiceEmail) {
                this.$set(this.billing, "email", this.invoiceEmail)
            }

            if (this.invoicePhone) {
                this.$set(this.billing, "phone", this.invoicePhone)
            }

            if (this.total == 0) {
                this.payment_method = 'purchase_order'
            }

            // Place order with Purchase OrderDetails Number
            this.cartData = this.getCartData();
            if (this.payment_method == 'purchase_order') {
                this.postOrder();
                return;
            }

            this.axios.post('/checkout/preCheckout', this.cartData)
                .then((response) => {
                    // Go to Payment Page
                    this.orderId = response.data.id
                    this.cartData.order_id = this.orderId
                    this.getToken();

                }).catch((err) => {
                    this.handleCheckoutError(err)
                }).finally(() => {

                });
            // return;
        },
        getCartData() {
            return {
                cart_token: this.$store.getters.getCartToken,
                quote_id: (this.quote || {}).quote_id,
                order_id: this.orderId,
                transaction_id: this.transactionId,
                transaction: this.transaction,
                recaptcha_token: this.captchaToken, // TODO: deprecated
                homeschool: this.isHomeschoolStore ? 1 : 0,
                blackout_windows: this.mergeWindows(),
                ship_anytime: this.blackoutNoWindows,
                openday: this.openday,
                school_year: this.schoolYear,
                shipping: {
                    0: {
                        address: this.shipping.school.address,
                        city: this.shipping.school.city,
                        first_name: this.shipping.first_name,
                        last_name: this.shipping.last_name,
                        email: this.shipping.email,
                        state: this.shipping.school.state,
                        zip: this.shipping.school.zip,
                        school: this.shipping.school,
                        // arrive_window: this.shipping.arrive_window,
                        products: this.products,
                    }
                },
                shipping_details: this.shipping,
                billing: this.billing,
                products: this.products,
                multiyear: this.multiyear,
                special_offers: this.special_offers,
                teaching_tips: this.teaching_tips,
                payment_method: this.payment_method,
                subscription_duration: this.subscription_duration,
                affiliate_id: this.affiliate.id,
                sweepstakes_code: this.invalidSweepstakesCode ? null : this.sweepstakes_code,
                discount_code: this.invalidDiscountCode ? null : this.discount_code,
                sw_email: this.credentials ? this.credentials.email: null,
                sw_password: this.credentials ? this.credentials.password: null,
                validated_shipping_ups_address_status: this.shippingAddressStatus,
                validated_shipping_ups_address_accepted: this.shippingAddressAccepted
            }
        },
        async getToken() {
            this.placingOrder = true;
            this.$store.dispatch('getFrameToken', this.cartData)
                .then(data => {
                    this.token = data.token;
                    this.showPaymentPage = true;
                    this.$nextTick(() => {
                        this.showForm();
                    })
                })
                .catch((error) => {
                    this.handleCheckoutError(error);
                })
                .finally(() => {
                })

        },
        hideForm() {
            this.displayForm = false;
            this.token = false;
            this.showPaymentPage = false;
        },
        showForm() {
            this.displayForm = true;
            this.placingOrder = false;

            // Note: settings these via script is 100% mandatory for the form to post into the target iFrame.
            // If not done, it will open in a new tab.
            this.$refs.send_token.target = 'add_payment';
            this.$refs.send_token.action = FRAME_URL;

            this.$refs.send_token.submit();
            window.scrollTo(0,0);
        },
        onReceiveCommunication(e) {
            const params = this.parseQueryString(e.qstr);
            switch (params["action"]) {
                case "successfulSave":
                    this.$emit('save', params);
                    // TODO: check docs for when this is supposed to be called
                    break;
                case "cancel":
                    this.showPaymentPage  = false;
                    this.placingOrder = false;
                    this.hideForm();
                    this.$emit('cancel', params);
                    break;
                case "resizeWindow":
                    this.$emit('resize', params);
                    const w = parseInt(params["width"]);
                    const h = parseInt(params["height"]) + 150;
                    const ifrm = this.$refs.add_payment;
                    ifrm.style.width = w.toString() + "px";
                    ifrm.style.height = h.toString() + "px";
                    break;
                case "transactResponse":
                    try {
                        // TODO: Need error handling here. this is refund territory
                        // this.$emit('transact', params);
                        this.displayForm = false;
                        this.transaction = JSON.parse(params['response']);
                        this.transactionId = this.transaction.transId;
                        this.cartData = this.getCartData();
                        this.postOrder();
                    }
                    catch (e) {
                        this.postProblem(e, params);
                    }
            }
        },
        parseQueryString(str) {
            let vars = {};
            let arr = str.split(/&(.*)/s);
            let pair;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === "")
                    continue;
                pair = arr[i].split(/=(.*)/s);
                vars[pair[0]] = unescape(pair[1]);
            }
            return vars;
        },
        postProblem(e, responseParams) {
            let cartData = {};
            try {
                cartData = this.getCartData();
            }
            catch (e) {}
            this.axios.post("/checkout/problem", {name: e.name, message: e.message, cause: e.cause, data: cartData, response: responseParams}).then((response) => {
                // DISPLAY ERROR TO USER, message saying contact customer support
                this.$swal({
                    toast: true,
                    html: `We encountered an unexpected error. Please Contact Customer Support <br/>
                           <strong>Error</strong>: ${e}`,
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    noAutoHide: true
                })
            });
        },
        postPO() {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('po_upload', this.po_upload);
                formData.append('existing_filename', this.po_filename);

                this.axios.post('/checkout/purchase_order', formData, {headers: {
                    'Content-Type': 'multipart/form-data'
                }})
                .then((response) => {
                    this.po_filename = response.data.po_filename;
                    this.$swal({
                        toast: true,
                        html: `Your Purchase Order has been successfully uploaded.`,
                        type: 'success',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 5000
                    })
                    resolve(response);

                })
                .catch((err) => {
                    this.$swal({
                        toast: true,
                        html: `There was an error uploading your Purchase Order. Please try again.`,
                        type: 'error',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 5000
                    });
                    reject(err);
                });
            })
        },
        async postOrder() {
            // for (let i = 0; i < this.products.length; ++i) {
            //     delete this.products[i].prices;
            // }
            this.placingOrder = true;

            try {
                // if (this.po_upload) {
                //     this.$bvModal.show('po_upload_modal');
                //     await this.postPO();
                //     this.cartData.po_filename = this.po_filename;
                //     this.hasUploadedPO = true;
                //     this.$bvModal.hide('po_upload_modal');
                // }

                let response = await this.axios.post("/checkout/checkout", this.cartData)
                this.validating = false

                let id = null

                if (response.data.id) {
                    id = response.data.id
                }

                this.$store.commit('clearCart');
                this.pushOrderToGoogleAnalytics(response.data, id);

                // clear cart
                this.$store.commit("setProducts", [])


                //clear sweepstakes code
                this.sweepstakes_code = null

                //clear discount code
                this.discount_code = null
                this.$store.commit('saveDiscountCode', null)
                this.$store.commit('addDiscount', null)

                // clear stored credentails for new account
                this.$store.commit("storeNewAccountCredentials", null)
                this.$store.commit('storeLastOrder', this.cartData);
                this.$router.push({
                    name: 'checkoutSuccess',
                    params: {
                        order_number: id
                    }
                })
                this.placingOrder = false
            }
            catch (error) {
                this.$bvModal.hide('po_upload_modal');

                // TODO: an error here is serious business.
                if (!this.transactionId) {
                    this.handleCheckoutError(error);
                    return;
                }
                this.postProblem(new Error("could not post order after payment"), error.response.data);
                this.errorMessage = `Your payment has been recevied, but we encountered an unexpected error while processing your order.
                           Please record your transaction id (${this.transactionId}) and contact customer support.
                           <strong>Error</strong>: ${JSON.stringify(error.response.data)}`;
                console.error("Checkout Error: ", error);
                this.$swal({
                    toast: true,
                    html: `We encountered an unexpected error. <br/>
                           <strong>Error</strong>: ${JSON.stringify(error.response.data)}`,
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    noAutoHide: true
                })
            }
        },
        pushOrderToGoogleAnalytics(responseData, invoiceId) {
            try {
                // add Google Analytics transaction to e-commerce
                this.$ga.query('ecommerce:addTransaction', {
                    id: invoiceId,
                    shipping: this.shippingCost,
                    tax: this.totalTax,
                    revenue: this.total
                })
                // this.$ga.ecommerce.addTransaction({
                //     id: id,
                //     shipping: this.shippingCost,
                //     tax: this.totalTax,
                //     revenue: this.total
                // })

                // add products to Google Analytics e-commerce
                _.forEach(this.products, product => {
                    // this.$ga.ecommerce.addItem({
                    //     id: product.legacy_id,
                    //     name: product.title,
                    //     category: product.state,
                    //     sku: product.sku,
                    //     quantity: product.quantity,
                    //     price: this.price(product.format, product.type, product.quantity, this.multiyear)
                    // })

                    let thisPrice

                    if (product.format) {
                        thisPrice = this.price(product.prices, product.format, product.type, product.quantity, this.multiyear).yearstotal
                    } else {
                        thisPrice = product.price
                    }

                    this.$ga.query('ecommerce:addItem', {
                        id: invoiceId,
                        name: product.title,
                        category: product.state,
                        sku: product.sku,
                        quantity: product.quantity,
                        price: thisPrice
                    })
                })

                // send Google Analytics e-commerce data
                this.$ga.query('ecommerce:send')
            }
            catch (e) {
                console.error("Google Analytics failed to track transaction", e);
            }
        },
        handleCheckoutError(error) {
            this.placingOrder = false
            console.error("Checkout Error:", JSON.stringify(error));
            this.displayForm = false;
            this.showPaymentPage = false;
            this.token = null;
            if (error.response.status == 429) {
                this.$swal({
                    toast: true,
                    html: `We encountered an error. Please try again.`,
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 5000
                })
                return;
            }

            // Validation Error
            if (error.response.status == 422) {
                let message = "There was a problem with your submission. <br/>Please check the form for errors or contact customer support.";
                if (error.response.data && error.response.data.message)
                    message += `<br/>${error.response.data.message}<br/>`;

                let validationErrors = [];
                for (const key in error.response.data.errors) {
                    if (error.response.data.errors.hasOwnProperty(key)) {
                        validationErrors.push(error.response.data.errors[key]);
                    }
                }
                this.$swal({
                    toast: true,
                    html: message + validationErrors.join('<br/>'),
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    noAutoHide: true
                })
                return;
            }

            let message = "";
            if (error.response.data)
                message = JSON.stringify(error.response.data);
            if (error.response.data.message)
                message = error.response.data.message;

            this.$swal({
                toast: true,
                html: `There was a problem creating your order. <br/> <br/> <strong>Reason</strong>: ${message}`,
                type: 'error',
                position: 'top-end',
                showConfirmButton: false,
                noAutoHide: true
            })
        },
        validCheckout () {
            if(this.total == 0){
                this.payment_method = 'free'
            }
            this.validating = true

            var valid = true

            let shippingFormRef = (this.address_type === 'custom') ? this.$refs.customShippingForm.$refs : this.$refs.schoolShippingForm.$refs;

            shippingFormRef.addressScrollTo.classList.remove('invalid')

            this.arriveWindowRangeError = null;

            if (this.billing_address_same) {
                this.setBillingToShippingInfo()
            }

            if (this.isHomeschoolStore) {
                this.shipping.school.name = `${this.shipping.first_name} ${this.shipping.last_name}`;
            }
            // Blackout dates required option
            // No windows and no checkmark

            if (this.blackoutWindows.length == 0 && !this.blackoutNoWindows) {
                valid = false;
                this.$refs.blackoutWindow.scrollIntoView({behavior: 'smooth', block: 'center'});
                this.arriveWindowRangeError = "If you have no dates that you are NOT available to receive shipments then please check 'I can receive shipments at any time'";
            }

            // Homeschool orders must choose a partial shipment option
            if (this.isHomeschoolStore && !this.shipping.canShipPartial && !this.shipping.cantShipPartial) {
                valid = false;
                this.$refs.shipPartial.scrollIntoView({behavior: 'smooth', block: 'center'});
            }

            this.$refs.shippingEmailAddress.state = null;
            if (!this.shippingEmail || !this.isValidEmail(this.shippingEmail)) {
                valid = false
                this.$refs.shippingEmailAddress.focus()
            }

            if (!this.acceptTos) {
                valid = false;
                this.showTOSAlert = true;
                console.log("TOS Alert");
            }

            if (this.isHomeschoolStore && !this.acceptHomeschoolAgreement) {
                valid = false;
                this.showHomeschoolAlert = true;
            }


            //Shipping Address Information
            //--------------------

            else if (!this.shipping.first_name) {
                valid = false
                this.$refs.shippingFirstName.focus()
            }

            else if (!this.shipping.last_name) {
                valid = false
                this.$refs.shippingLastName.focus()
            }



            // if address type is "school" and no school has been found and selected
            else if (!this.isHomeschoolStore && this.address_type == 'school' && !this.shipping.school.id) {
                valid = false
                this.$refs.schoolSearch.$el.focus()
            }

            /*
                if address type is "custom" and no address information has been input
            */

            else if (this.address_type == 'custom' && !this.shipping.school.name) {
                valid = false
                this.$refs.shippingSchoolName.focus()
            }


            else if (!this.shipping.school.address) {
                valid = false
                shippingFormRef.address.focus()
            }

            else if (!this.shipping.school.city) {
                valid = false
                shippingFormRef.city.focus()
            }

            else if (!this.shipping.school.state) {
                valid = false
                shippingFormRef.state.focus()
            }

            else if (!this.shipping.school.zip || !this.shipping.school.zip.match(/^\d{5}(-\d{4})?$/)) {
                valid = false
                shippingFormRef.zip.focus()
            }
            else if (!this.shippingAddressAccepted) {
                valid = false;
                shippingFormRef.addressScrollTo.classList.add('invalid');
                shippingFormRef.addressScrollTo.scrollIntoView({behavior: 'smooth', block: 'center'});
            }

            //--------------------

            else if (!this.shipping.school_year) {
                valid = false
                this.$refs.shippingSchoolYear.focus()
            }

            /*
                if payment type is "card" and no card information has been input
            */
            // else if ((this.payment_method == 'card' || this.payment_method == 'plan') && !this.card.number) {
            //     valid = false
            //     this.$refs.cardNumber.$el.focus()
            // }

            // else if ((this.payment_method == 'card' || this.payment_method == 'plan') && !this.card.expiration) {
            //     valid = false
            //     this.$refs.cardExpiration.$el.focus()
            // }
            //
            // else if ((this.payment_method == 'card' || this.payment_method == 'plan') && !this.card.cvv) {
            //     valid = false
            //     this.$refs.cardCVV.focus()
            // }

            /*
                if payment type is "purchase order" and no information has been input
            */
            else if (this.payment_method == 'purchase_order' && !this.billing.purchase_order) {
                valid = false
                this.$refs.purchaseOrderNumber.focus()
            }

            else if (
                this.address_type == 'custom' &&
                this.payment_method == 'purchase_order' &&
                !this.shipping.school.association
            ) {
                valid = false
                this.$refs.shippingSchoolAssociation.focus()
            }

            else if (!this.invoiceEmail || !this.isValidEmail(this.invoiceEmail)) {
                valid = false
                this.$refs.invoiceEmail.focus()
            }

            else if (!this.invoicePhone || !this.isValidPhone(this.invoicePhone)) {
                valid = false
                this.$refs.invoicePhone.focus()
            }

            //Billing Information
            //--------------------

            if (this.isHomeschoolStore && !this.isValidPhone(this.shipping.school.phone)) {
                valid = false;
                this.$refs.shippingPhone.focus();
            }

            // Don't validate other billing fields if same as shipping.
            if (this.billing_address_same) {
                return valid;
            }

            /*
                if billing address type is "custom" and no address information has been input
            */
            else if (this.billing_address_type == 'custom' && !this.billing.school) {
                valid = false
                this.$refs.billingSchoolName.focus()
            }

            else if (this.billing_address_type == 'custom' && !this.billing.address) {
                valid = false
                this.$refs.billingAddressForm.$refs.address.focus()
            }

            else if (this.billing_address_type == 'custom' && !this.billing.city) {
                valid = false
                this.$refs.billingAddressForm.$refs.city.focus()
            }

            else if (this.billing_address_type == 'custom' && !this.billing.state) {
                valid = false
                this.$refs.billingAddressForm.$refs.state.focus()
            }

            else if (this.billing_address_type == 'custom' && (!this.billing.zip || !this.shipping.school.zip.match(/^\d{5}(-\d{4})?$/))) {
                valid = false
                this.$refs.billingAddressForm.$refs.zip.focus()
            }

            else if (this.billing_address_type == 'custom' && this.billing.zip.length < 5) {
                valid = false
                this.$refs.billingAddressForm.$refs.zip.focus()
            }

            // else if (
            //     this.billing_address_type == 'custom' &&
            //     (!this.billingAddressVerified && !this.acceptBillingAddressResponsibility)
            // ) {
            //     valid = false
            //     this.$refs.billingAcceptResponsibility.focus()
            // }

            // if billing address type is "school" and no school has been found and selected
            else if (this.billing_address_type == 'school' && !this.billing.id) {
                valid = false
                this.$refs.billingSchoolSearch.$el.focus()
            }

            //--------------------

            return valid
        },
        setBillingToShippingInfo() {
            //Set Billing Info To Currenty Set Shipping Info

            let po = this.billing.purchase_order

            this.billing = _.clone(this.shipping.school)
            this.billing.purchase_order = po

            this.billing_address_type = this.address_type

            this.billing.first_name = this.shipping.first_name
            this.billing.last_name = this.shipping.last_name

            if(this.shipping.school.id) {
                this.billing.id = this.shipping.school.id
            }
            else if(this.payment_method == "purchase_order" && this.billing.association) {
                this.billing.id = this.billing.association
            }
            else {
                this.billing.id = null
            }

            if(this.shipping.school.id) {
                this.billing.id = this.shipping.school.id
            }
            if (this.shipping.school.id) {
                this.billing.id = this.shipping.school.id
            }

            if (this.isHomeschoolStore) {
                this.invoiceEmail = this.shipping.email;
                if (this.shipping.school.phone)
                    this.invoicePhone = this.sanitizePhone(this.shipping.school.phone);
            }

            this.billing_school_search = null
        },
        copySchool () {
            if (this.address_type !== 'school') {
                //
                // this.school = _.cloneDeep(this.shipping.school)
                //
                // this.shipping.school = {}
                this.school_search = null

                this.shipping.school = {
                    association: ""
                }
                // this.shipping.school.association = ""
            }
        },
        copyBillingSchool () {
            if (this.billing_address_type !== 'school') {

                this.billing_school_search = null
            }
        },
        searchSchools: _.debounce(function(searchTerm) {
            // if (!searchTerm || searchTerm.length < 5) return
            if (searchTerm && searchTerm.length >= 5) {
                this.isLoading = true

                this.axios.get("checkout/schools?zip=" + searchTerm)
                .then(response => {
                    this.isLoading = false

                    this.schools = response.data.schools;
                    this.schools.sort((a,b) => a.name > b.name ? 1 : (a.name < b.name) ? -1 : 0);

                    // Check for empty list
                    if (!this.schools.length) {
                        this.$swal({
                            toast: true,
                            html: 'We could not find any schools matching your search. If you believe this an error, please wait a few minutes and try again.',
                            type: 'warning',
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 5000
                        })
                    }
                })
                .catch(error => {
                    this.$swal("Error", error.message, "error")
                })
            }
        }, 500),
        setSchool (school) {
            console.log('Setting School', school);
            this.shipping.school = school

            if (!this.shipping.school.address) {
                this.needs_shipping_address = true;
            } else {
                this.needs_shipping_address = false;
            }
            this.shippingAddressAccepted = true;

            if (this.billing_address_same)
                this.billing = _.cloneDeep(school)
        },
        unsetSchool () {
            this.shipping.school = {}
        },
        searchBillingSchools: _.debounce(function(searchTerm) {
            // if (!searchTerm || searchTerm.length < 5) return
            if (searchTerm && searchTerm.length >= 5) {
                this.isLoading = true

                this.axios.get("checkout/schools?zip=" + searchTerm)
                .then(response => {
                    this.isLoading = false

                    this.billing_schools = response.data.schools
                    this.billing_schools.sort((a,b) => a.name > b.name ? 1 : (a.name < b.name) ? -1 : 0);
                })
                .catch(error => {
                    this.$swal("Error", error.message, "error")
                })
            }
        }, 500),
        setBillingSchool (school) {
            console.log(school);
            if (!this.billing)
                this.billing = {};

            this.billing.id = school.id
            this.billing.school = school.name
            this.billing.address = school.address
            this.billing.city = school.city
            this.billing.state = school.state
            this.billing.zip = school.zip
        },
        unsetBillingSchool () {
            this.billing.id = null;
            this.billing.school = null;
            this.billing.address = null;
            this.billing.city = null;
            this.billing.state = null;
            this.billing.zip = null;
        },
        dateIsAllowedForWindow({date}) {
            if (!this.blackoutWindows.length || !this.blackoutWindows[0] || !this.blackoutWindows[0].start) {
                return null;
            }

            return this.blackoutWindows.map(({start, end}) => {
                let dates = [];
                let currentDate = new Date(start);
                let endDate = new Date(end);
                while (currentDate <= endDate) {
                    dates.push(new Date (currentDate));
                    let newDate = new Date(currentDate.valueOf());
                    newDate.setDate(newDate.getDate() + 1);
                    currentDate = newDate;
                }
                console.log(dates);
                return dates;
            });
        },
        validateRange (event, windowIndex) {
            if (!event || !event.start) return;

            var windowStart = moment(event.start);
            var windowEnd = moment(event.end);
            this.arriveWindowRangeError = null;

            // Hide datepicker
            this.$refs[`blackoutWindow_${windowIndex}`][0].$el.style = 'display: none;';
        },
        price (product_prices, format, type, quantity, multiyear) {
            var prices = productPricesOfFormat(product_prices, format, quantity, this.isHomeschoolStore)[multiyear]

            return prices
        },
        price_old (format, type, quantity) {
            // TODO: remove this function
            if (format == 'online_only') return 5.49
            if (type == 'classroom' && quantity >= 10) return 7.95
            if (type == 'classroom' && quantity < 10) return 29.95
        },
        applySweepstakesCode (sweepstakes_code) {
            this.applyingSweepstakesCode = true

            // if(this.isSweepstakesAllowedForCurrentState() == true) {
            //     this.applyingSweepstakesCode = false
            // }
            // else {
                this.axios.get("/checkout/sweepstakes?sweepstakes=" + this.sweepstakes_code, {

                }).then(response => {
                    if (response.data && response.data.success) {
                        this.invalidSweepstakesCode = false

                        var response = response.data

                        var sweepstakes = 1

                        this.$store.commit('saveSweepstakesCode', sweepstakes_code)
                        this.$store.commit('addSweepstakes', sweepstakes)

                    } else {
                        this.invalidSweepstakesCode = true

                        this.$refs.sweepstakesCode.focus()
                        this.$refs.sweepstakesCode.select()
                    }

                    this.applyingSweepstakesCode = false
                })
                .catch(error => {
                    this.applyingSweepstakesCode = false

                    this.$refs.sweepstakesCode.focus()
                    this.$refs.sweepstakesCode.select()

                    this.$swal({
                        toast: true,
                        html: error.message,
                        type: 'error',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 5000
                    })
                })
            // }
        },
        get_current_selected_state () {
            let current_selected_state = null
            if(current_selected_state == null && this.shipping.school.state) {
                    current_selected_state = this.shipping.school.state
            }
            // else if(current_selected_state == null && this.billing.school.state) {
            //     current_selected_state = this.billing.school.state
            // }
            else if(current_selected_state == null && this.selectedState) {
                current_selected_state = this.selectedState
            }

            return current_selected_state
        },
        isDiscountAllowedForCurrentState (discountCode) {
            if (discountCode != null && discountCode.toUpperCase() == "EARLY24") {
                return !EARLY24_BLOCKED_STATES.includes(this.get_current_selected_state());
            }

            return !(states_disallow_discount_codes.includes(this.get_current_selected_state()));
        },
        getDiscountCodeType (discount_code) {
            let discount_code_type = null

            if(discount_code == 'BUNDLE2020') {
                discount_code_type = 'bundle-with-all-matching-products'
            }
            else if(discount_code == 'BUNDLE25') {
                discount_code_type = 'bundle-with-2nd-product'
            }
            else if(discount_code == 'WELLBEING2020') {
                discount_code_type = 'single-product'
            }
            else if(discount_code == 'AFFILIATE') {
                discount_code_type = 'full-cart-excluding-online-only'
            }
            else {
                discount_code_type = 'full-cart-excluding-online-only'
            }

            return discount_code_type
        },
        getDiscountCodeSingleProductSku (discount_code) {
            let discount_code_single_product_sku = null

            if(discount_code == 'WELLBEING2020') {
                discount_code_single_product_sku = 'JTMKIT'
            }

            return discount_code_single_product_sku
        },
        getCartCosts(silent = false, discountCode = null) {

            if (this.dontFetchPrices)
                return Promise.resolve({});

            // Default discountCode to current form input.
            if (!discountCode && this.discount_code)
                discountCode = this.discount_code;

            return new Promise((resolve, reject) => {
                // if (!this.productsById.length) {
                //     resolve();
                //     return;
                // }

                this.$store.dispatch('cartCosts', {
                    discount_code: discountCode,
                    homeschool: this.isHomeschoolStore ? 1 : 0,
                    payment_method: this.payment_method,
                    school_year: this.schoolYear,
                    shipping: {
                        "-1": {
                            state: this.shipping.school.state,
                            zip: this.shipping.school.zip,
                            address: this.shipping.school.address,
                            city: this.shipping.school.city,
                            products: this.productsById,
                        }
                    },
                    multiyear: this.multiyear,
                }).then(data => {
                        // Handle Discounts
                        if (data.discount_total > 0 && data.discounts) {
                            this.invalidDiscountCode = false;

                            this.discounts = data.discounts;
                            for (let i = 0; i < this.discounts.length; ++i) {
                                if (this.discounts[i].type === 'discount_code') {
                                    this.discount_code = discountCode;
                                    this.$store.commit('saveDiscountCode', discountCode);
                                    this.$store.commit('addDiscount', this.discounts[i].discount_amount);
                                    break;
                                }
                            }

                        } else {
                            data.discounts = [];
                        }
                        this.shippingCost = data.shipping_total;
                        this.totalTax = data.tax_total;
                        this.cardFee = data.credit_card_fee;
                        if (data.tax_rates)
                            this.taxrate = data.tax_rates[Object.keys(data.tax_rates)[0]];

                        resolve(data);
                        return;
                }).catch(error => {

                    // Handle specified errors
                    if (error.data && !error.data.success) {
                        if (error.data.message.match(/to_zip [a-zA-Z0-9]+ is not used within to_state [a-zA-Z]+/) !== null) {
                            this.$swal({
                                toast: true,
                                html: `Something went wrong, please make sure the shipping zip code matches the shipping state.`,
                                type: 'error',
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 5000
                            })
                            return;
                        }
                    }

                    this.invalidDiscountCode = true;
                    if (silent) {
                        reject();
                        return;
                    }

                    if (this.$refs.discountCode) {
                        this.$refs.discountCode.focus()
                        this.$refs.discountCode.select()
                    }

                    this.$swal({
                        toast: true,
                        html: `Something went wrong, please contact customer support. ${error.message}`,
                        type: 'error',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 5000
                    })
                    reject();
                })
            })
        },
        canApplyDiscount(discountCode) {
            let allowedCode = (STORE_ALLOWED_DISCOUNT_CODES.indexOf(discountCode.toUpperCase()) !== -1);
            let bundleAllowedInState = (this.isDiscountAllowedForCurrentState(discountCode) == true);
            return allowedCode && bundleAllowedInState;
        },
        applyDiscountCode (discount_code) {

            this.applyingDiscountCode = true

            this.discount_code_type = this.getDiscountCodeType(discount_code)
            this.discount_code_single_product_sku = this.getDiscountCodeSingleProductSku(discount_code)

            // Invalid Code
            if(!this.canApplyDiscount(discount_code)) {
                this.applyingDiscountCode = false

                this.invalidDiscountCode = true

                this.$refs.discountCode.focus()
                this.$refs.discountCode.select()

                // this.$swal({
                //     toast: true,
                //     html: 'Discount Codes not allowed in this state.',
                //     type: 'error',
                //     position: 'top-end',
                //     showConfirmButton: false,
                //     timer: 5000
                // })
                return;
            }

            // No State Selected
            if (this.get_current_selected_state() == null) {
                this.applyingDiscountCode = false

                this.$refs.discountCode.focus()
                this.$refs.discountCode.select()

                this.$swal({
                    toast: true,
                    html: 'Please provide a shipping address.',
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 5000
                })
                return;
            }

            // Affiliate Discount
            if (discount_code == 'AFFILIATE') {
                var discount = 0.05

                this.$store.commit('saveDiscountCode', discount_code)
                this.$store.commit('addDiscount', discount)

                this.refreshProductDiscounts(0, false)
                return;
            }

            // Allowed Code
            this.getCartCosts().finally(() => {
                this.applyingDiscountCode = false;
            });

            // console.log('discount=' + this.discount)
            // console.log('discount_code=' + this.discount_code)
        },
        clearSweepstakes () {
            if (this.invalidSweepstakesCode) {
                this.invalidSweepstakesCode = false

                this.$refs.sweepstakesCode.focus()
            }

            this.$swal({
                text: "Are you sure you want to remove this sweepstakes code?",
                showCancelButton: true,
                confirmButtonText: 'Remove Sweepstakes Code',
                confirmButtonClass: 'btn btn-danger',
                cancelButtonText: 'Cancel',
                cancelButtonClass: 'btn btn-light',
                buttonsStyling: false,
                reverseButtons: true
            }).then((willClearSweepstakes) => {
                if (willClearSweepstakes.value) {
                    this.sweepstakes_code = null

                    this.$store.commit('saveSweepstakesCode', null)
                    this.$store.commit('addSweepstakes', null)
                }
            })
        },
        clearDiscount () {
            if (this.invalidDiscountCode) {
                this.invalidDiscountCode = false

                this.$refs.discountCode.focus()
            }

            this.$swal({
                text: "Are you sure you want to remove this discount?",
                showCancelButton: true,
                confirmButtonText: 'Remove Discount',
                confirmButtonClass: 'btn btn-danger',
                cancelButtonText: 'Cancel',
                cancelButtonClass: 'btn btn-light',
                buttonsStyling: false,
                reverseButtons: true
            }).then((willClearDiscount) => {
                if (willClearDiscount.value) {

                    _.forEach(this.products, product => {
                        product.discount_code_type = 'none'
                        product.discount = 0
                    })

                    this.discount_code = null
                    this.discounts = [];

                    this.$store.commit('saveDiscountCode', null)
                    this.$store.commit('addDiscount', null)
                    this.getCartCosts();
                }

                this.applyingDiscountCode = false
            })
        },
        clearDiscount_NoConfirm () {
            if (this.invalidDiscountCode) {
                this.invalidDiscountCode = false

                this.$refs.discountCode.focus()
            }

            this.discount_code = null
            this.discounts = [];
            this.$store.commit('saveDiscountCode', null)
            this.$store.commit('addDiscount', null)
        },
        formattedState (productState) {
            var formattedState = null

            _.forEach(this.publicationStates, state => {
                if (productState == state.state) {
                    formattedState = state.fullState
                }
            })

            return formattedState
        },
        getProductQuantities (products, byGrade=true, topic=null, language=null) {

            let qtyOfTopic = []
            let grade = 0
            let product
            let thisProductTopic

            for(grade=0; grade<=8; grade++) {
                if(!qtyOfTopic[grade]) { qtyOfTopic[grade] = 0 }
            }

            for (product of products) {
                // if(product.topic == 'National Social Studies' || product.topic == 'Wellbeing') {
                if(product.topic == 'Social Studies' || product.topic == 'National Social Studies') {
                    thisProductTopic = 'Social Studies'
                }
                else {
                    thisProductTopic = product.topic
                }

                if(language != null) {
                    if(product.language == language) {
                        if(topic != null) {
                            if(thisProductTopic == topic) {
                                qtyOfTopic[product.grade] = qtyOfTopic[product.grade] + product.quantity;
                            }
                        }
                        else {
                            qtyOfTopic[product.grade] = qtyOfTopic[product.grade] + product.quantity;
                        }
                    }
                }
                else {
                    if(topic != null) {
                        if(thisProductTopic == topic) {
                            qtyOfTopic[product.grade] = qtyOfTopic[product.grade] + product.quantity;
                        }
                    }
                    else {
                        qtyOfTopic[product.grade] = qtyOfTopic[product.grade] + product.quantity;
                    }
                }
            }

            if(byGrade != true) {
                let qtyOfTopicAll = 0;

                for(grade=0; grade<=8; grade++) {
                    qtyOfTopicAll = qtyOfTopicAll + qtyOfTopic[grade]
                }

                return qtyOfTopicAll
            }
            else {
                return qtyOfTopic
            }
        },
        refreshProductDiscounts(bundleDiscount, checkingBundle = null) {

            let validBundle = false

            let qtyOfScience = []
            let qtyOfSocialStudies = []
            let qtyOfSocialStudiesEnglish = []
            let qtyOfSocialStudiesSpanish = []
            let qtyOfScienceEnglish = []
            let qtyOfScienceSpanish = []

            //Default All Combinations to 0
            //--------------------
            let grade

            for(grade=0; grade<=8; grade++) {
                this.discount_by_topic[grade] = {
                    'Social Studies': {
                        'en': 0,
                        'es': 0,
                    },
                    'National Social Studies': {
                        'en': 0,
                        'es': 0,
                    },
                    'Science': {
                        'en': 0,
                        'es': 0,
                    },
                }
            }
            //--------------------

            if(checkingBundle == true || this.discount_code_type == 'bundle-with-2nd-product' || this.discount_code_type == 'bundle-with-all-matching-products') {

                qtyOfScience = this.getProductQuantities (this.products, true, 'Science')

                qtyOfSocialStudies = this.getProductQuantities (this.products, true, 'Social Studies')

                qtyOfSocialStudiesEnglish = this.getProductQuantities (this.products, true, 'Social Studies', 'en')

                qtyOfSocialStudiesSpanish = this.getProductQuantities (this.products, true, 'Social Studies', 'es')

                qtyOfScienceEnglish = this.getProductQuantities (this.products, true, 'Science', 'en')

                qtyOfScienceSpanish = this.getProductQuantities (this.products, true, 'Science', 'es')

                //Bundle w/ 2 Topics
                // if($qtyOfScience['all-grades'] >= 10 AND $qtyOfSocialStudies['all-grades'] >= 10) {
                //     //Rules Matched
                //     //Science (10+) + Social Studies (10+)

                //     $validBundle = true;
                // }

                //Bundle w/ 2 Topics & Grades
                for(grade=0; grade<=8; grade++) {
                    if(qtyOfScience[grade] >= 10 && qtyOfSocialStudies[grade] >= 10) {
                        if(qtyOfScience[grade] == qtyOfSocialStudies[grade]) {
                            //Rules Matched
                            //Science (10+) + Social Studies (10+)

                            if(this.discount_code_type == 'bundle-with-2nd-product') {
                                this.discount_by_topic[grade]['Social Studies']['en'] = 0
                                this.discount_by_topic[grade]['Social Studies']['es'] = 0

                                this.discount_by_topic[grade]['National Social Studies']['en'] = 0
                                this.discount_by_topic[grade]['National Social Studies']['es'] = 0
                            }
                            else {
                                this.discount_by_topic[grade]['Social Studies']['en'] = bundleDiscount
                                this.discount_by_topic[grade]['Social Studies']['es'] = bundleDiscount

                                this.discount_by_topic[grade]['National Social Studies']['en'] = bundleDiscount
                                this.discount_by_topic[grade]['National Social Studies']['es'] = bundleDiscount
                            }

                            this.discount_by_topic[grade]['Science']['en'] = bundleDiscount
                            this.discount_by_topic[grade]['Science']['es'] = bundleDiscount

                            validBundle = true
                        }
                    }
                }

                //Bundle w/ Social Studies & 2 Languages
                // if($qtyOfSocialStudiesEnglish['all-grades'] >= 10 AND $qtyOfSocialStudiesSpanish['all-grades'] >= 10) {
                //     //Rules Matched
                //     //Social Studies English (10+) = Social Studies Spanish (10+)

                //     $validBundle = true;
                // }

                //Bundle w/ Social Studies & 2 Languages & Grades
                for(grade=0; grade<=8; grade++) {
                    if(qtyOfSocialStudiesEnglish[grade] >= 10 && qtyOfSocialStudiesSpanish[grade] >= 10) {
                        if(qtyOfSocialStudiesEnglish[grade] == qtyOfSocialStudiesSpanish[grade]) {
                            //Rules Matched
                            //Social Studies English (10+) = Social Studies Spanish (10+)

                            this.discount_by_topic[grade]['Social Studies']['en'] = bundleDiscount
                            this.discount_by_topic[grade]['National Social Studies']['en'] = bundleDiscount

                            if(this.discount_code_type == 'bundle-with-2nd-product') {
                                this.discount_by_topic[grade]['Social Studies']['es'] = 0
                                this.discount_by_topic[grade]['National Social Studies']['es'] = 0
                            }
                            else {
                                this.discount_by_topic[grade]['Social Studies']['es'] = bundleDiscount
                                this.discount_by_topic[grade]['National Social Studies']['es'] = bundleDiscount
                            }

                            validBundle = true
                        }
                    }
                }
            }

            return validBundle
        },
        autoApplyCoupon() {

            return; // Feature disabled September 2026

            if (this.isHomeschoolStore)
                return;

            if (this.products.length < 2)
                return;

            let discountCode = this.products.length > 2 ? 'BUNDLE3' : 'BUNDLE2';
            if (!this.canApplyDiscount(discountCode)) {
                console.log("Stopped auto coupon");
                return;
            }

            // Try auto applying bundle2 or bundle 3
            this.getCartCosts(true, discountCode).then((responseData) => {
                if (!responseData || !responseData.discounts)
                    return;

                // Check if discount was applied.
                for (let i = 0; i < responseData.discounts.length; ++i) {
                    if (responseData.discounts[i].type == 'discount_code') {
                        return;
                    }
                }

                // No need to check for bundle2 again, if we already did.
                if (discountCode !== 'BUNDLE3')
                    return;

                discountCode = 'BUNDLE2';
                this.getCartCosts(true, discountCode).then((response2Data) => {
                    if (!response2Data || !response2Data.discounts)
                        return;

                    this.discount_code = '';
                    this.clearDiscount_NoConfirm();
                })
            });
        },
    },
    created() {
        console.log('Multiyear:', this.multiyear);
        this.products = this.$store.getters.getCartProducts;

        if (this.isHomeschoolStore) {
            this.billing_address_same = false;
        }

        console.log(this.quote);
        if (this.quote != null && this.quote.quote_id) {
            this.autoPopulateFromQuote(this.quote);
        }


        this.getCharterSchools();
    },
    mounted () {
        // Attach iframe listener
        if (!window.AuthorizeNetIFrame) window.AuthorizeNetIFrame = {};
        AuthorizeNetIFrame.onReceiveCommunication = (e) => this.onReceiveCommunication(e);

        if (this.isHomeschoolStore) {
            this.address_type = 'custom';
        }

        if (this.saved_discount_code) {
            // this.discount_code = this.saved_discount_code
        }

        if(!this.discount_code || this.discount_code == null) {

            if(this.affiliate.id) {
                // this.applyDiscountCode ('AFFILIATE')
                // this.discount_code = 'AFFILIATE'
            }
            else {
                this.clearDiscount_NoConfirm();
            }
        }

        if (this.saved_sweepstakes_code) {
            this.sweepstakes_code = this.saved_sweepstakes_code
        }

        if (!this.shipping.school_year)
            this.$set(this.shipping, 'school_year', this.schoolYear);

        this.autoApplyCoupon();
    }
}
</script>

